/* GCB2B-I18N:dict — display strings resolve through the gcb2b-i18n section's dictionary (translatable settings)
   with the English literal as the fallback; keys carrying {n} / {c} / {p} are templates. scripts/patch-js-i18n.mjs */
window.gcT = window.gcT || (function(){ var d = null;
  /* every host section (quote form, products, industries) emits its own fragment; merge them all */
  function load(){ var els = document.querySelectorAll('script.gcb2b-i18n-dict'); if (!els.length) return null; var out = {}; for (var i = 0; i < els.length; i++) { try { var o = JSON.parse(els[i].textContent || '{}'); for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) out[k] = o[k]; } catch (e) {} } return out; }
  return function(s){ var k = String(s == null ? '' : s); if (d === null) { d = load(); if (d === null) return k; } var v = Object.prototype.hasOwnProperty.call(d, k) ? d[k] : ''; return (typeof v === 'string' && v) ? v : k; };
})();
/* generated colour names are "<modifier> <family>"; both halves translate, the modifier as a template so word order can change */
/* The drawer label lower-cases the product name mid-sentence ("sub-types of card holders"); German capitalises nouns, so it keeps the dictionary form */
window.gcLowerProduct = window.gcLowerProduct || function(s){ s = String(s == null ? '' : s); return (document.documentElement.lang || 'en').toLowerCase().indexOf('de') === 0 ? s : s.toLowerCase(); };
window.gcColorName = window.gcColorName || function(name){ var s = String(name == null ? '' : name); var m = /^(Black|Midnight|Deep|Dark|Soft|Light|Pale|Cream|Dusty|Muted|Rich|Vivid) (.+)$/.exec(s); if (!m) return window.gcT(s); return window.gcT(m[1] + ' {c}').replace('{c}', window.gcT(m[2])); };
/* The quote summary shows back what the buyer picked, read from the hidden inputs that carry the English values sent to the
   atelier ("Card Holders — Slim 4-card"). Translate each half for display only; the hidden value stays English. */
window.gcTParts = window.gcTParts || function(s){ return String(s == null ? '' : s).split(' — ').map(function(p){ return window.gcT(p.trim()); }).join(' — '); };
/* country suggestions in the quote form: the curated list is English; every other storefront language shows the browser's own
   region names (Intl.DisplayNames, ISO 3166 codes below); the English name is the fallback when the API is missing */
window.gcRegionName = window.gcRegionName || (function(){
  var ISO = {'United States':'US','United Kingdom':'GB','Germany':'DE','France':'FR','Italy':'IT','United Arab Emirates':'AE','Singapore':'SG','Switzerland':'CH','Canada':'CA','Australia':'AU','Austria':'AT','Belgium':'BE','Bulgaria':'BG','Croatia':'HR','Cyprus':'CY','Czech Republic':'CZ','Denmark':'DK','Estonia':'EE','Finland':'FI','Greece':'GR','Hungary':'HU','Iceland':'IS','Ireland':'IE','Latvia':'LV','Lithuania':'LT','Luxembourg':'LU','Malta':'MT','Netherlands':'NL','Norway':'NO','Poland':'PL','Portugal':'PT','Romania':'RO','Slovakia':'SK','Slovenia':'SI','Spain':'ES','Sweden':'SE','Mexico':'MX','China':'CN','Hong Kong':'HK','India':'IN','Indonesia':'ID','Japan':'JP','Malaysia':'MY','New Zealand':'NZ','Philippines':'PH','South Korea':'KR','Taiwan':'TW','Thailand':'TH','Vietnam':'VN','Bahrain':'BH','Israel':'IL','Kuwait':'KW','Oman':'OM','Qatar':'QA','Saudi Arabia':'SA','Turkey':'TR','Argentina':'AR','Brazil':'BR','Chile':'CL','Colombia':'CO','Costa Rica':'CR','Panama':'PA','Peru':'PE','Uruguay':'UY','Egypt':'EG','Kenya':'KE','Morocco':'MA','Nigeria':'NG','South Africa':'ZA'};
  var lang = document.documentElement.lang || 'en', dn = null;
  return function(en){ var code = ISO[en]; if (!code || lang.toLowerCase().indexOf('en') === 0) return en;
    if (dn === null) { try { dn = (window.Intl && Intl.DisplayNames) ? new Intl.DisplayNames([lang], { type: 'region' }) : false; } catch (e) { dn = false; } }
    if (!dn) return en; try { return dn.of(code) || en; } catch (e) { return en; } };
})();
/* GENTCREATE B2B hub — generated by build-hub.mjs. Wrapped in a block so top-level const/let cannot collide with theme globals;
 * function declarations remain reachable by the inline handlers (Annex B). Production pass: IIFE + delegated events. */
(function(){
  var root = document.querySelector('#main .gcb2b');
  if (!root) return;
  ["navBurger","mobileDrawer","headerLocale","loginModal","signinForm","registerForm","chatbot","chatbot-body","chat-input"].forEach(function(id){
    if (!document.getElementById(id)) { var d = document.createElement('div'); d.id = id; d.hidden = true; d.setAttribute('data-gcb2b-stub',''); root.appendChild(d); }
  });
})();
{
/* ---- from: body ---- */

  (function(){
    var deck=document.getElementById('m27-deck'); if(!deck) return;
    var cards=[].slice.call(deck.querySelectorAll('.m27-card'));
    var dotsWrap=document.getElementById('m27-dots');
    var capWrap=document.getElementById('m27-caption');
    var catEl=document.getElementById('m27-cat'), nameEl=document.getElementById('m27-name'), ctaEl=document.getElementById('m27-cta');
    var n=cards.length, pos=0, timer=null, INTERVAL=5200, dragging=false;

    // build dots
    cards.forEach(function(c,i){
      var d=document.createElement('button'); d.className='m27-dot'+(i===0?' active':'');
      d.setAttribute('role','tab'); d.setAttribute('aria-label',(c.dataset.name?gcT(c.dataset.name):gcT('Piece {n}').replace('{n}',i+1)));
      d.addEventListener('click',function(){go(i,true);});
      dotsWrap.appendChild(d);
    });
    var dots=[].slice.call(dotsWrap.children);

    // ---- continuous fractional-position coverflow ----
    // every card's transform is a smooth function of its signed distance to the
    // current (fractional) position, so neighbouring cards grow / shrink / rotate
    // INTO each other as you drag, then ease-snap on release. one shared 4-fn
    // transform list => the browser interpolates every state, centre card included.
    function spacing(){ var w=window.innerWidth; return w<=600?150:(w<=980?224:300); }
    function relOf(i,p){ var d=i-p; while(d>n/2) d-=n; while(d<-n/2) d+=n; return d; }
    function place(c,rel){
      var ar=Math.abs(rel), sp=spacing();
      var x=rel*sp;
      var sc=Math.max(.48, 1-ar*0.16);
      var ry=Math.max(-26,Math.min(26,-rel*9));
      var op=ar>2.7?0:Math.max(0,1-ar*0.36);
      c.style.transform='translate(calc(-50% + '+x.toFixed(1)+'px),-50%) scale('+sc.toFixed(3)+') perspective(900px) rotateY('+ry.toFixed(2)+'deg)';
      c.style.opacity=op.toFixed(3);
      c.style.zIndex=Math.round(100-ar*10);
      c.style.pointerEvents=ar<1.5?'auto':'none';
    }
    function layout(p){
      cards.forEach(function(c,i){ place(c,relOf(i,p)); });
      var act=((Math.round(p)%n)+n)%n;
      cards.forEach(function(c,i){ c.classList.toggle('is-active',i===act); });
    }
    var capIdx=-1;
    function swapCaption(i){
      if(i===capIdx) return; capIdx=i;
      var c=cards[i];
      capWrap.classList.add('swapping');
      setTimeout(function(){ catEl.textContent=gcT(c.dataset.cat||''); nameEl.textContent=gcT(c.dataset.name||''); capWrap.classList.remove('swapping'); },180);
    }
    // pos is a free running float; relOf() wraps, so the index never jumps.
    function go(i,user){
      deck.classList.remove('dragging'); pos=i; layout(pos);
      var a=((Math.round(i)%n)+n)%n;
      dots.forEach(function(d,k){ d.classList.toggle('active',k===a); });
      swapCaption(a);
      if(user) restart();
    }
    window.m27Step=function(dir){ go(Math.round(pos)+dir,true); };

    // active-card click + CTA -> prefill quote
    cards.forEach(function(c,i){
      c.addEventListener('click',function(){
        if(c.classList.contains('is-active')){ prefillAndQuote(c.dataset.name); }
        else { go(i,true); }
      });
    });
    function curName(){ return cards[((Math.round(pos)%n)+n)%n].dataset.name||''; }
    ctaEl.addEventListener('click',function(e){ if(ctaEl.tagName==='A'){ e.preventDefault(); } prefillAndQuote(curName()); });
    function prefillAndQuote(name){ gcAddToQuote(name||''); }

    // autoplay (pause on hover/focus/offscreen/hidden tab/drag)
    function tick(){ go(Math.round(pos)+1,false); }
    function start(){ if(!timer && !dragging) timer=setInterval(tick,INTERVAL); }
    function stop(){ if(timer){ clearInterval(timer); timer=null; } }
    function restart(){ stop(); start(); }
    var stage=document.querySelector('.m27-stage');
    [stage,capWrap].forEach(function(el){ el.addEventListener('mouseenter',stop); el.addEventListener('mouseleave',start); el.addEventListener('focusin',stop); el.addEventListener('focusout',start); });
    document.addEventListener('visibilitychange',function(){ document.hidden?stop():start(); });
    // only autoplay when in view
    if('IntersectionObserver' in window){
      new IntersectionObserver(function(es){ es.forEach(function(e){ e.isIntersecting?start():stop(); }); },{threshold:.25}).observe(document.getElementById('m27'));
    } else { start(); }

    // continuous finger-following drag (mouse + touch + pen). cards merge live as
    // you swipe; on release we ease-snap to the nearest piece over the CSS glide.
    var startX=0, startPos=0, dragMoved=false;
    function dragDown(e){ dragging=true; dragMoved=false; startX=e.clientX; startPos=Math.round(pos); deck.classList.add('dragging'); stage.classList.add('grabbing'); stop(); }
    function dragMove(e){ if(!dragging) return; var dx=e.clientX-startX; if(Math.abs(dx)>4) dragMoved=true; pos=startPos - dx/spacing(); layout(pos); }
    function dragUp(){ if(!dragging) return; dragging=false; stage.classList.remove('grabbing'); go(Math.round(pos), true); }
    stage.addEventListener('pointerdown', dragDown);
    window.addEventListener('pointermove', dragMove, {passive:true});
    window.addEventListener('pointerup', dragUp);
    window.addEventListener('pointercancel', dragUp);
    // a real drag must not also fire a card click (jump / prefill-quote)
    deck.addEventListener('click', function(e){ if(dragMoved){ e.preventDefault(); e.stopPropagation(); dragMoved=false; } }, true);
    // re-place on resize so the coverflow spacing stays responsive
    window.addEventListener('resize', function(){ layout(pos); });
    // keyboard when section focused
    document.getElementById('m27').addEventListener('keydown',function(e){ if(e.key==='ArrowLeft'){e.preventDefault();go(Math.round(pos)-1,true);} else if(e.key==='ArrowRight'){e.preventDefault();go(Math.round(pos)+1,true);} });

    layout(0); swapCaption(0);
  })();
  

/* ---- from: body ---- */

    (function(){
      var r=document.querySelector('.m04-rail');if(!r)return;
      var steps=r.querySelectorAll('.m04-step');
      if(!('IntersectionObserver' in window)){r.classList.add('in-view');steps.forEach(function(s){s.classList.add('in-view-step');});return;}
      var rail=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){r.classList.add('in-view');rail.disconnect();}})},{threshold:.12});
      rail.observe(r);
      var stepIO=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('in-view-step');stepIO.unobserve(e.target);}})},{rootMargin:'0px 0px -30% 0px',threshold:.35});
      steps.forEach(function(s){stepIO.observe(s);});
    })();
    (function initM24bChips(){
      function bindGroup(selector,hiddenId,onChange){
        var chips=document.querySelectorAll(selector);
        var hidden=document.getElementById(hiddenId);
        if(!chips.length||!hidden)return;
        chips.forEach(function(c){
          c.addEventListener('click',function(ev){
            ev.preventDefault();
            chips.forEach(function(x){x.classList.remove('active');x.setAttribute('aria-pressed','false');});
            c.classList.add('active');c.setAttribute('aria-pressed','true');
            var val=c.dataset.leather||c.dataset.color||'';
            hidden.value=val;
            hidden.dispatchEvent(new Event('change'));
            if(typeof onChange==='function')onChange(c,val);
          });
        });
      }
      function start(){
        bindGroup('.m24b-leather-chip','m24bLeather');
        bindGroup('.m24b-color-chip','m24bColor',function(c,val){
          var sw=document.getElementById('m24b-color-swatch');
          var nm=document.getElementById('m24b-color-name');
          var hx=document.getElementById('m24b-color-hex');
          var bg=(c.getAttribute('style')||'').match(/background\s*:\s*([^;]+)/i);
          var hex=bg?bg[1].trim():'';
          var hm=hex.match(/#([0-9a-f]{3,8})/i);
          if(sw)sw.style.background=hex;
          if(nm)nm.textContent=val;
          if(hx)hx.textContent=hm?('#'+hm[1].toUpperCase()):'';
        });
      }
      if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);
      else start();
    })();
    /* GCB2B-WIRE:sample-kit */
    /* Written by scripts/patch-sample-kit-form.mjs (idempotent). Replaces the mockup handler, which
       validated with blocking browser dialogs and then opened /pages/contact-us in a new tab with
       the enquiry in query parameters that page never reads: the buyer landed on an empty form and
       the configuration was lost. The section now posts natively to Shopify.
       This listener composes contact[body] so the atelier receives the configuration (Shopify
       forwards only a handful of named fields), keys the success and error panels to this form,
       and validates the two chip groups inline — their mirrors are hidden inputs, which are barred
       from constraint validation, so the browser cannot enforce them. Never preventDefault on a
       valid submit: the native POST is the transport. */
    (function(){
      var NL=String.fromCharCode(10);
      var GROUPS=[
        ['m24bLeather','m24bLeatherErr','.m24b-leather-chip'],
        ['m24bColor','m24bColorErr','.m24b-color-chip']
      ];
      function start(){
        var f=document.getElementById('gcb2b-sample-kit');
        if(!f||f.gcb2bSkInit){return;}
        f.gcb2bSkInit=1;
        function drop(el){if(el&&el.parentNode){el.parentNode.removeChild(el);}}
        function byName(n){return f.querySelector('[name="contact['+n+']"]');}
        function val(n){var el=byName(n);return el?String(el.value||'').trim():'';}
        /* Shopify sets form.posted_successfully? on EVERY contact form on the page, so the panel
           that actually posted is the one named by the hash Shopify appends to the action. */
        var mine=(location.hash||'')===('#'+f.id);
        var done=f.querySelector('[data-gcb2b-done]');
        var errs=f.querySelector('[data-gcb2b-errors]');
        if(done){
          if(mine){f.classList.add('is-posted');try{done.focus();done.scrollIntoView({block:'center'});}catch(x){}}
          else{drop(done);}
        }
        if(errs){
          if(mine){try{errs.focus();errs.scrollIntoView({block:'center'});}catch(x){}}
          else{drop(errs);}
        }
        function mark(g,bad){
          var err=document.getElementById(g[1]);
          if(err){err.hidden=!bad;}
          var first=f.querySelector(g[2]);
          if(first){first.setAttribute('aria-invalid',bad?'true':'false');}
          return first;
        }
        GROUPS.forEach(function(g){
          var h=document.getElementById(g[0]);
          if(h){h.addEventListener('change',function(){if(h.value){mark(g,false);}});}
        });
        function firstMissing(){
          var bad=null;
          GROUPS.forEach(function(g){
            var h=document.getElementById(g[0]);
            var empty=!(h&&String(h.value||'').trim());
            var el=mark(g,empty);
            if(empty&&!bad){bad=el;}
          });
          return bad;
        }
        /* Shopify forwards only a handful of named fields to the mailbox, so restate the whole
           configuration in the body under the routing marker. No price, no credit claim and no
           turnaround is stated here; commercial terms belong in the written quote. */
        function compose(){
          var ta=byName('body');
          if(!ta){return;}
          if(typeof ta.gcb2bBase!=='string'){ta.gcb2bBase=ta.defaultValue||ta.value||'';}
          var out=[ta.gcb2bBase];
          var pairs=[
            ['Name',val('name')],['Email',val('email')],['Leather',val('leather')],
            ['Colour',val('colour')],['Foil',val('foil')],['Ship to',val('ship_to')],
            ['Initials',val('initials')]
          ];
          pairs.forEach(function(p){if(p[1]){out.push(p[0]+': '+p[1]);}});
          ta.value=out.join(NL);
        }
        function label(){
          var b=f.querySelector('.m24b-cta');
          return b?b.querySelector('span'):null;
        }
        f.addEventListener('submit',function(ev){
          var bad=firstMissing();
          if(bad){
            ev.preventDefault();
            try{bad.focus();bad.scrollIntoView({block:'center'});}catch(x){}
            return;
          }
          compose();
          var b=f.querySelector('.m24b-cta');
          if(b){b.setAttribute('aria-busy','true');}
          var l=label();
          if(l&&!l.getAttribute('data-gc-label')){l.setAttribute('data-gc-label',l.textContent);}
          setTimeout(function(){if(l){l.textContent=gcT('Sending your request');}},0);
        });
        window.addEventListener('pageshow',function(){
          var b=f.querySelector('.m24b-cta');
          if(b){b.removeAttribute('aria-busy');}
          var l=label();
          var t=l&&l.getAttribute('data-gc-label');
          if(t){l.textContent=t;}
        });
      }
      if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',start);}
      else{start();}
    })();

    /* Region typeahead combobox: buyer types any country, gets ranked matches from a curated 60-country B2B shipping list. Keyboard nav + click-to-select + outside-click-close. The input accepts ANY value (we ship globally) — the list is a guide, not a restriction. */
    (function(){
      var REGIONS = [
        {g:'Most Common', items:['United States','United Kingdom','Germany','France','Italy','United Arab Emirates','Singapore','Switzerland','Canada','Australia']},
        {g:'Europe', items:['Austria','Belgium','Bulgaria','Croatia','Cyprus','Czech Republic','Denmark','Estonia','Finland','France','Germany','Greece','Hungary','Iceland','Ireland','Italy','Latvia','Lithuania','Luxembourg','Malta','Netherlands','Norway','Poland','Portugal','Romania','Slovakia','Slovenia','Spain','Sweden','Switzerland','United Kingdom']},
        {g:'North America', items:['Canada','Mexico','United States']},
        {g:'Asia Pacific', items:['Australia','China','Hong Kong','India','Indonesia','Japan','Malaysia','New Zealand','Philippines','Singapore','South Korea','Taiwan','Thailand','Vietnam']},
        {g:'Middle East', items:['Bahrain','Israel','Kuwait','Oman','Qatar','Saudi Arabia','Turkey','United Arab Emirates']},
        {g:'Latin America', items:['Argentina','Brazil','Chile','Colombia','Costa Rica','Mexico','Panama','Peru','Uruguay']},
        {g:'Africa', items:['Egypt','Kenya','Morocco','Nigeria','South Africa']}
      ];
      /* Flatten + de-duplicate so suggestions are stable across groups. Keep group hint for top results. */
      var FLAT = (function(){
        var seen = {}, out = [];
        REGIONS.forEach(function(g){
          g.items.forEach(function(it){
            var key = it.toLowerCase();
            if (!seen[key]){ seen[key] = g.g; out.push({name:window.gcRegionName(it), group:g.g}); }
          });
        });
        return out;
      })();

      document.querySelectorAll('[data-m24b-combo]').forEach(function(combo){
        var input = combo.querySelector('.m24b-combo-input');
        var list = combo.querySelector('.m24b-combo-list');
        if (!input || !list) return;
        var activeIdx = -1;

        function escapeHtml(s){ return s.replace(/[&<>"]/g, function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
        function highlightMatch(name, q){
          if (!q) return escapeHtml(name);
          var lower = name.toLowerCase(), idx = lower.indexOf(q.toLowerCase());
          if (idx < 0) return escapeHtml(name);
          return escapeHtml(name.slice(0,idx)) + '<mark>' + escapeHtml(name.slice(idx, idx+q.length)) + '</mark>' + escapeHtml(name.slice(idx+q.length));
        }
        function filter(q){
          q = (q||'').toLowerCase().trim();
          if (!q){
            /* Empty input: show "Most Common" group first as guidance */
            return REGIONS[0].items.slice(0,10).map(function(it){return {name:window.gcRegionName(it),group:'Most Common'};});
          }
          /* Score: startsWith > contains; preserve original order within bucket */
          var starts = [], contains = [];
          FLAT.forEach(function(r){
            var lr = r.name.toLowerCase();
            if (lr.indexOf(q) === 0) starts.push(r);
            else if (lr.indexOf(q) > 0) contains.push(r);
          });
          return starts.concat(contains).slice(0,10);
        }
        function render(matches, q){
          list.innerHTML = '';
          if (!matches.length){
            var empty = document.createElement('li');
            empty.className = 'm24b-combo-empty';
            empty.textContent = gcT('No match, we ship globally. Press Enter to keep what you typed.');
            list.appendChild(empty);
            return;
          }
          /* Optional group header on empty-input mode */
          if (!q){
            var head = document.createElement('li');
            head.className = 'm24b-combo-group';
            head.textContent = gcT('Suggested');
            list.appendChild(head);
          }
          matches.forEach(function(r){
            var li = document.createElement('li');
            li.setAttribute('role','option');
            li.dataset.value = r.name;
            li.innerHTML = highlightMatch(r.name, q);
            li.addEventListener('mousedown', function(e){
              e.preventDefault();
              input.value = r.name;
              close();
              input.dispatchEvent(new Event('change', {bubbles:true}));
            });
            list.appendChild(li);
          });
        }
        function open(){
          render(filter(input.value), input.value.trim());
          list.hidden = false;
          combo.setAttribute('aria-expanded','true');
          activeIdx = -1;
        }
        function close(){
          list.hidden = true;
          combo.setAttribute('aria-expanded','false');
          activeIdx = -1;
        }
        function highlight(items){
          items.forEach(function(it, i){ it.setAttribute('aria-selected', i === activeIdx ? 'true' : 'false'); });
          if (items[activeIdx]) items[activeIdx].scrollIntoView({block:'nearest'});
        }

        input.addEventListener('focus', open);
        input.addEventListener('input', function(){ open(); });
        input.addEventListener('keydown', function(e){
          var items = list.querySelectorAll('li[role=option]');
          if (e.key === 'ArrowDown'){ e.preventDefault(); if (list.hidden) open(); activeIdx = Math.min(items.length - 1, activeIdx + 1); highlight(items); }
          else if (e.key === 'ArrowUp'){ e.preventDefault(); activeIdx = Math.max(0, activeIdx - 1); highlight(items); }
          else if (e.key === 'Enter'){
            if (activeIdx >= 0 && items[activeIdx]){
              e.preventDefault();
              input.value = items[activeIdx].dataset.value;
              close();
              input.dispatchEvent(new Event('change', {bubbles:true}));
            } else {
              /* Enter with free text accepts whatever was typed. Don't preventDefault so the form submit can still run if user hits Enter from this field. */
              close();
            }
          }
          else if (e.key === 'Escape'){ close(); }
        });
        document.addEventListener('click', function(e){
          if (!combo.contains(e.target)) close();
        });
      });
    })();
  

/* ---- from: proof ---- */

        (function(){
          var vids=[].slice.call(document.querySelectorAll('video.m26-trust-vid'));
          if(!vids.length || !('IntersectionObserver' in window)) return;
          var io=new IntersectionObserver(function(es){es.forEach(function(e){
            var v=e.target;
            if(e.isIntersecting){ if(v.paused) v.play().catch(function(){}); }
            else if(!v.paused){ v.pause(); }
          });},{threshold:.2});
          vids.forEach(function(v){ io.observe(v); });
        })();
        

/* ---- from: body ---- */

  const CHAT_KB = [{"q":"What is your minimum order quantity?","a":"Our MOQ is 25 units across the leather product range. Mixed-product orders count toward the same MOQ tier."},{"q":"How fast can I get a quote and sample?","a":"Written quotes return within 1 business day. Material reference packs are included with every Business / Enterprise quote, and a physical product proof for orders above 250 units takes 7-10 days."},{"q":"Can you do crocodile or python?","a":"Yes. We work with CITES-certified crocodile (Himalayan, Siamese, Nile, Caiman), American alligator, and python (Diamondback, Reticulated, Burmese, Karung). Exotic upcharge starts at 4x base price."},{"q":"What's lead time for 500 units?","a":"Standard lead time is 2-4 weeks from approved digital proof. Rush production (10 business days) available for an upcharge."},{"q":"Do you ship internationally?","a":"Yes. We ship to 18 countries with DHL Express included on Business and Enterprise tiers."},{"q":"What payment terms?","a":"50% deposit / 50% on shipment by default. Net 30 available for repeat customers and orders above $10,000."},{"q":"Can we do brand collaborations?","a":"Yes, we partner with brands, celebrities, athletes, and creators on capsule collections. Apply via the Brand Collaboration section above; minimum commitment is 500 units across the line."},{"q":"I need a product not on your site (e.g. leather pants)","a":"We can produce almost any leather product. Submit a custom request via the search bar in the product section or contact wholesale@gentcreate.com with sketches/reference photos."},{"q":"Do you have hotel & restaurant items?","a":"Yes, we make menu covers, check presenters, key card holders, room number plaques, do-not-disturb tags, slipper pouches, robe ties, and coasters."},{"q":"What's the largest order you've shipped?","a":"5,000-unit single drop, 12,000 units across a multi-year program (mixed years-of-service tiers for an EU consultancy of 2,100 employees)."}];
  const SUB_ICONS = {"bifold":"<path d=\"M3 7h18v10H3z\"/><path d=\"M12 7v10\"/>","trifold":"<path d=\"M3 7h18v10H3z\"/><path d=\"M9 7v10M15 7v10\"/>","long":"<path d=\"M5 4h14v16H5z\"/><path d=\"M5 12h14\"/>","slim":"<path d=\"M3 9h18v6H3z\"/><path d=\"M7 12h10\"/>","clip":"<path d=\"M3 8h18v8H3z\"/><path d=\"M5 6v12M19 6v12.1\"/><path d=\"M3 12h6\"/>","card1":"<rect x=\"5\" y=\"7\" width=\"14\" height=\"10\" rx=\"1.2\"/><path d=\"M5 11h14\"/>","card4":"<rect x=\"3\" y=\"9\" width=\"14\" height=\"9\" rx=\"1\"/><rect x=\"5\" y=\"7\" width=\"14\" height=\"9\" rx=\"1\"/><rect x=\"7\" y=\"5\" width=\"14\" height=\"9\" rx=\"1\"/>","card8":"<rect x=\"3\" y=\"11\" width=\"13\" height=\"8\" rx=\"1\"/><rect x=\"5\" y=\"9\" width=\"13\" height=\"8\" rx=\"1\"/><rect x=\"7\" y=\"7\" width=\"13\" height=\"8\" rx=\"1\"/><rect x=\"9\" y=\"5\" width=\"13\" height=\"8\" rx=\"1\"/>","cascade":"<path d=\"M4 18l8-12M9 19l8-13M14 20l8-13\"/><circle cx=\"6\" cy=\"18\" r=\"1.2\"/><circle cx=\"11\" cy=\"19\" r=\"1.2\"/><circle cx=\"16\" cy=\"20\" r=\"1.2\"/>","rfid":"<path d=\"M12 3l8 3v6c0 4-3 7-8 9-5-2-8-5-8-9V6z\"/><path d=\"M9 12c1-1 2-1 3-1s2 0 3 1\"/><path d=\"M7 10c2-2 3-2 5-2s3 0 5 2\"/>","one":"<circle cx=\"12\" cy=\"12\" r=\"6\"/><path d=\"M11 9v6h2\"/>","multi":"<circle cx=\"7\" cy=\"9\" r=\"3\"/><circle cx=\"17\" cy=\"9\" r=\"3\"/><circle cx=\"7\" cy=\"17\" r=\"3\"/><circle cx=\"17\" cy=\"17\" r=\"3\"/>","travel":"<rect x=\"4\" y=\"8\" width=\"16\" height=\"11\" rx=\"1.5\"/><path d=\"M9 8V5h6v3M12 11v5\"/>","zipper":"<path d=\"M3 7h18v10H3z\"/><path d=\"M5 12h14M7 9l1 1.5-1 1.5M10 9l1 1.5-1 1.5M13 9l1 1.5-1 1.5M16 9l1 1.5-1 1.5\"/>","magnet":"<path d=\"M5 5v8a7 7 0 0014 0V5h-4v8a3 3 0 01-6 0V5z\"/>","doc":"<path d=\"M6 3h9l4 4v14H6z\"/><path d=\"M15 3v4h4M9 11h7M9 15h7M9 19h5\"/>","pocket":"<rect x=\"4\" y=\"6\" width=\"16\" height=\"14\" rx=\"1\"/><path d=\"M4 12h16\"/><path d=\"M9 14v3M15 14v3\"/>","sketch":"<path d=\"M4 20l3-1L17 9l-2-2L5 17z\"/><path d=\"M14 6l3 3\"/>","round":"<circle cx=\"12\" cy=\"12\" r=\"8\"/>","square":"<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\"/>","edge":"<rect x=\"3\" y=\"3\" width=\"18\" height=\"18\" stroke-width=\"2.4\"/>","felt":"<rect x=\"4\" y=\"6\" width=\"16\" height=\"12\"/><circle cx=\"8\" cy=\"10\" r=\".7\" fill=\"currentColor\"/><circle cx=\"12\" cy=\"10\" r=\".7\" fill=\"currentColor\"/><circle cx=\"16\" cy=\"10\" r=\".7\" fill=\"currentColor\"/><circle cx=\"8\" cy=\"14\" r=\".7\" fill=\"currentColor\"/><circle cx=\"12\" cy=\"14\" r=\".7\" fill=\"currentColor\"/><circle cx=\"16\" cy=\"14\" r=\".7\" fill=\"currentColor\"/>","hotel":"<path d=\"M4 21V8l8-5 8 5v13\"/><path d=\"M9 21v-6h6v6M9 12h.01M15 12h.01\"/>","yacht":"<circle cx=\"12\" cy=\"12\" r=\"7\"/><path d=\"M12 5v3M12 16v3M5 12h3M16 12h3M7 7l2 2M15 15l2 2M7 17l2-2M15 9l2-2\"/><circle cx=\"12\" cy=\"12\" r=\"1.4\" fill=\"currentColor\"/>","sport":"<path d=\"M14 3l-9 12h6l-1 6 9-12h-6z\"/>","smartkey":"<circle cx=\"9\" cy=\"12\" r=\"4\"/><path d=\"M13 12h7M17 12v3M20 12v2\"/><circle cx=\"9\" cy=\"12\" r=\"1\" fill=\"currentColor\"/>","shop":"<path d=\"M3 9l2-5h14l2 5\"/><path d=\"M3 9v11h18V9\"/><path d=\"M9 20v-7h6v7\"/>","glovebox":"<rect x=\"3\" y=\"7\" width=\"18\" height=\"11\" rx=\"2\"/><path d=\"M3 12h18M12 12v6\"/>","tasting":"<rect x=\"6\" y=\"3\" width=\"12\" height=\"18\" rx=\"1\"/><path d=\"M9 7h6M9 11h6M9 15h4\"/>","bottle":"<path d=\"M10 3h4v4l1 2v9a3 3 0 01-3 3h0a3 3 0 01-3-3V9z\"/><path d=\"M10 12h4\"/>","cocktail":"<path d=\"M4 5h16l-7 9v6\"/><path d=\"M9 20h6\"/>","smile":"<circle cx=\"12\" cy=\"12\" r=\"8\"/><circle cx=\"9\" cy=\"10\" r=\".7\" fill=\"currentColor\"/><circle cx=\"15\" cy=\"10\" r=\".7\" fill=\"currentColor\"/><path d=\"M9 14c1 1.5 2 2 3 2s2-.5 3-2\"/>","banquet":"<ellipse cx=\"12\" cy=\"14\" rx=\"9\" ry=\"3\"/><path d=\"M3 14v3a9 3 0 0018 0v-3\"/><circle cx=\"12\" cy=\"14\" r=\"2.5\"/>","wedding":"<circle cx=\"9\" cy=\"14\" r=\"4\"/><circle cx=\"15\" cy=\"14\" r=\"4\"/><path d=\"M7 7l2 3M17 7l-2 3\"/>","trophy":"<path d=\"M8 4h8v5a4 4 0 01-8 0z\"/><path d=\"M5 5h3M16 5h3M10 13h4l-1 4h-2z\"/><path d=\"M9 20h6\"/>","plaque":"<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"1\"/><rect x=\"8\" y=\"9\" width=\"8\" height=\"6\"/>","cufflink":"<circle cx=\"8\" cy=\"12\" r=\"3\"/><circle cx=\"16\" cy=\"12\" r=\"3\"/><path d=\"M11 12h2\"/>","watch1":"<circle cx=\"12\" cy=\"12\" r=\"5\"/><path d=\"M9 7l1-3h4l1 3M9 17l1 3h4l1-3\"/><path d=\"M12 10v3l2 1\"/>","watch3":"<circle cx=\"6\" cy=\"12\" r=\"3\"/><circle cx=\"12\" cy=\"12\" r=\"3\"/><circle cx=\"18\" cy=\"12\" r=\"3\"/>","phone":"<rect x=\"7\" y=\"3\" width=\"10\" height=\"18\" rx=\"2\"/><path d=\"M11 18h2\"/>","tablet":"<rect x=\"4\" y=\"3\" width=\"16\" height=\"18\" rx=\"2\"/><path d=\"M11 18h2\"/>","airpod":"<path d=\"M9 4c-3 0-4 2-4 5v3c0 4 1 6 4 6 1 0 2-1 2-3v-8c0-2-1-3-2-3z\"/><path d=\"M15 4c3 0 4 2 4 5v3c0 4-1 6-4 6-1 0-2-1-2-3v-8c0-2 1-3 2-3z\"/>","magsafe":"<rect x=\"6\" y=\"3\" width=\"12\" height=\"18\" rx=\"2\"/><circle cx=\"12\" cy=\"11\" r=\"3.5\"/>","folio":"<path d=\"M3 6h7l2 2h9v11H3z\"/>","camera":"<rect x=\"3\" y=\"7\" width=\"18\" height=\"13\" rx=\"1.5\"/><circle cx=\"12\" cy=\"13\" r=\"3.5\"/><path d=\"M9 7l1-2h4l1 2\"/>","strap":"<path d=\"M3 12c4-6 14-6 18 0M3 12c4 6 14 6 18 0\"/>","belt":"<path d=\"M3 11h18v3H3z\"/><rect x=\"9\" y=\"9\" width=\"6\" height=\"7\"/><circle cx=\"13\" cy=\"12.5\" r=\".7\" fill=\"currentColor\"/>","loop":"<circle cx=\"12\" cy=\"14\" r=\"6\"/><path d=\"M12 8V4\"/>","tassel":"<path d=\"M9 4h6v3l-1 3h-4l-1-3z\"/><path d=\"M9 10v9M11 10v10M13 10v10M15 10v9\"/>","dring":"<path d=\"M8 4h2a8 8 0 010 16H8z\"/><path d=\"M5 4h3v16H5z\"/>","hook":"<path d=\"M12 3v8a4 4 0 11-4 4\"/><circle cx=\"12\" cy=\"3\" r=\"1.5\" fill=\"currentColor\"/>","crew":"<circle cx=\"6\" cy=\"8\" r=\"2.5\"/><circle cx=\"12\" cy=\"6.5\" r=\"3\"/><circle cx=\"18\" cy=\"8\" r=\"2.5\"/><path d=\"M3 18c0-2 1.5-4 3-4s3 2 3 4M9 19c0-3 1.5-5 3-5s3 2 3 5M15 18c0-2 1.5-4 3-4s3 2 3 4\"/>","plane":"<path d=\"M21 12l-9 6V13l-8 1v-4l8 1V6z\"/>","boat":"<path d=\"M3 16h18l-2 4H5z\"/><path d=\"M5 16V9l7-5 7 5v7\"/><path d=\"M12 4v12.1\"/>","cushion":"<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"3\"/><path d=\"M4 8c4 1 12 1 16 0M4 16c4-1 12-1 16 0\"/>","mount":"<path d=\"M3 21V8h6v13M9 14h6M15 14V5h6v16\"/>","drawstring":"<path d=\"M6 8h12l-1 12H7z\"/><path d=\"M6 8c0-2 3-3 6-3s6 1 6 3\"/><circle cx=\"9\" cy=\"6.5\" r=\"1\"/><circle cx=\"15\" cy=\"6.5\" r=\"1\"/>","snap":"<rect x=\"4\" y=\"6\" width=\"16\" height=\"13\" rx=\"1.5\"/><circle cx=\"12\" cy=\"12.5\" r=\"2\"/><circle cx=\"12\" cy=\"12.5\" r=\".7\" fill=\"currentColor\"/>","stitch":"<path d=\"M3 9h18M3 12h18M3 15h18\" stroke-dasharray=\"2 2\"/>","engrave":"<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\"/><path d=\"M9 15l3-7 3 7M10 13h4\"/>","pen":"<path d=\"M14 4l6 6L10 20H4v-6z\"/><path d=\"M14 4l6 6\"/>","cable":"<path d=\"M3 7c4 0 4 4 0 4s-4 4 0 4 4 4 0 4\"/><circle cx=\"3\" cy=\"7\" r=\"1.2\" fill=\"currentColor\"/><circle cx=\"3\" cy=\"19\" r=\"1.2\" fill=\"currentColor\"/>","collar":"<circle cx=\"12\" cy=\"13\" r=\"7\"/><rect x=\"10.5\" y=\"3\" width=\"3\" height=\"4\"/><circle cx=\"12\" cy=\"17\" r=\"1\" fill=\"currentColor\"/>","golf":"<circle cx=\"8\" cy=\"18\" r=\"2.5\"/><path d=\"M8 16V4l9 5z\"/>","cigar":"<rect x=\"3\" y=\"11\" width=\"16\" height=\"3\" rx=\"1.5\"/><path d=\"M19 12c2-1 2-1 0-2M19 14c2 1 2 1 0 2\"/>","whisky":"<path d=\"M7 5h10l-1 14H8z\"/><path d=\"M9 14h6\"/>","photo":"<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\"/><circle cx=\"9\" cy=\"10\" r=\"1.5\"/><path d=\"M4 17l5-5 7 7\"/><path d=\"M14 13l3-3 3 3\"/>","diploma":"<path d=\"M5 5l14 1v8l-14 1z\"/><circle cx=\"12\" cy=\"18\" r=\"3\"/><path d=\"M11 21l1 2 1-2\"/>","book":"<path d=\"M5 4h14v16H7a2 2 0 01-2-2z\"/><path d=\"M9 4v16M5 18h2\"/>","film":"<rect x=\"3\" y=\"6\" width=\"18\" height=\"12\"/><circle cx=\"6\" cy=\"9\" r=\".7\" fill=\"currentColor\"/><circle cx=\"6\" cy=\"15\" r=\".7\" fill=\"currentColor\"/><circle cx=\"18\" cy=\"9\" r=\".7\" fill=\"currentColor\"/><circle cx=\"18\" cy=\"15\" r=\".7\" fill=\"currentColor\"/><circle cx=\"12\" cy=\"9\" r=\".7\" fill=\"currentColor\"/><circle cx=\"12\" cy=\"15\" r=\".7\" fill=\"currentColor\"/>","music":"<path d=\"M9 18V5l10-2v13\"/><circle cx=\"7\" cy=\"18\" r=\"2\"/><circle cx=\"17\" cy=\"16\" r=\"2\"/>","vintage":"<path d=\"M4 7l5-3h11v16H9l-5-3z\"/><circle cx=\"13\" cy=\"9\" r=\"1.4\"/><path d=\"M9 4v16\"/>","speaker":"<rect x=\"9\" y=\"3\" width=\"6\" height=\"13\" rx=\"3\"/><path d=\"M5 11v1a7 7 0 0014 0v-1M12 19v3M9 22h6\"/>","envelope":"<rect x=\"3\" y=\"6\" width=\"18\" height=\"13\"/><path d=\"M3 6l9 7 9-7\"/>","lanyard":"<rect x=\"8\" y=\"9\" width=\"8\" height=\"11\" rx=\"1\"/><path d=\"M9 9l-2-5h10l-2 5\"/>","badge":"<circle cx=\"12\" cy=\"9\" r=\"5\"/><path d=\"M9 13l-2 8 5-3 5 3-2-8\"/>","pet":"<circle cx=\"6\" cy=\"9\" r=\"2\"/><circle cx=\"18\" cy=\"9\" r=\"2\"/><circle cx=\"9\" cy=\"6\" r=\"2\"/><circle cx=\"15\" cy=\"6\" r=\"2\"/><path d=\"M8 14c0-2 2-3 4-3s4 1 4 3 1 5-4 5-4-3-4-5z\"/>","bowtie":"<path d=\"M3 8l9 4-9 4zM21 8l-9 4 9 4z\"/><rect x=\"11\" y=\"10\" width=\"2\" height=\"4\"/>","large":"<rect x=\"3\" y=\"6\" width=\"18\" height=\"13\"/>","medium":"<rect x=\"5\" y=\"7\" width=\"14\" height=\"11\"/>","small":"<rect x=\"7\" y=\"9\" width=\"10\" height=\"7\"/>","refill":"<rect x=\"6\" y=\"3\" width=\"12\" height=\"18\" rx=\"1\"/><path d=\"M9 8h6M9 12h6M9 16h6\"/><path d=\"M6 7h2M6 11h2M6 15h2\"/>","pocketbook":"<rect x=\"7\" y=\"3\" width=\"10\" height=\"14\" rx=\"1\"/><path d=\"M10 7h4M10 11h4\"/>","travelbk":"<rect x=\"6\" y=\"3\" width=\"12\" height=\"18\" rx=\"1\"/><path d=\"M12 3v18M9 7h2M13 7h2M9 12h2M13 12h2M9 17h2M13 17h2\"/>","hardcover":"<rect x=\"4\" y=\"4\" width=\"16\" height=\"16\" rx=\"1\"/><rect x=\"6\" y=\"6\" width=\"12\" height=\"12\" stroke-dasharray=\"1.5 1.5\"/>","ergo":"<path d=\"M4 10c4-3 12-3 16 0v4c-4-3-12-3-16 0z\"/>","xl":"<rect x=\"3\" y=\"7\" width=\"18\" height=\"11\" rx=\"1.5\"/><path d=\"M3 11h18M3 14h18\"/>","threepen":"<path d=\"M5 4h2l8 14M9 4h2l8 14M13 4h2l8 14\"/>","flap":"<rect x=\"4\" y=\"6\" width=\"16\" height=\"13\"/><path d=\"M4 6l8 6 8-6\"/>","weekender":"<rect x=\"3\" y=\"9\" width=\"18\" height=\"11\" rx=\"2\"/><path d=\"M8 9V5h8v4M8 14h8\"/>","duffel":"<rect x=\"3\" y=\"9\" width=\"18\" height=\"9\" rx=\"4.5\"/><path d=\"M9 9V6h6v3M3 13h18\"/>","messenger":"<path d=\"M5 8h14l-1 12H6z\"/><path d=\"M5 8c0-2 3-3 7-3s7 1 7 3M9 11v3\"/>","bucket":"<path d=\"M5 8h14l-2 12H7z\"/><path d=\"M5 8c2-3 12-3 14 0\"/>","shopper":"<path d=\"M5 9h14l-1 11H6z\"/><path d=\"M9 9V5h6v4\"/>","attache":"<rect x=\"3\" y=\"7\" width=\"18\" height=\"13\"/><path d=\"M9 7V4h6v3M3 13h18\"/>","rolltop":"<path d=\"M5 8c2-3 12-3 14 0v12H5z\"/><path d=\"M5 11h14\"/>","cabinbag":"<rect x=\"5\" y=\"6\" width=\"14\" height=\"14\"/><path d=\"M9 6V3h6v3M5 12h14\"/>","trunk":"<rect x=\"4\" y=\"6\" width=\"16\" height=\"13\"/><path d=\"M4 11h16M4 15h16M9 6V4h6v2\"/>","garment":"<path d=\"M8 4h8l3 4v12H5V8z\"/><path d=\"M10 4l2 3 2-3\"/>","buckle":"<path d=\"M4 11h16v3H4z\"/><rect x=\"9\" y=\"8\" width=\"6\" height=\"9\"/><circle cx=\"12\" cy=\"12.5\" r=\"1.4\"/>","sphere":"<circle cx=\"12\" cy=\"12\" r=\"7\"/><path d=\"M5 12h14M12 5v14M7 7c4 5 6 5 10 0M7 17c4-5 6-5 10 0\"/>","pin":"<path d=\"M12 3l3 6h6l-5 4 2 7-6-4-6 4 2-7-5-4h6z\"/>","ribbon":"<path d=\"M8 4l-3 7h6l-3 9 8-9h-6l3-7z\"/>","mic":"<rect x=\"9\" y=\"3\" width=\"6\" height=\"11\" rx=\"3\"/><path d=\"M5 11v1a7 7 0 0014 0v-1M12 19v3\"/>","pulpit":"<rect x=\"4\" y=\"3\" width=\"16\" height=\"14\"/><path d=\"M12 3v14M4 17h16M9 21h6M12 17v4\"/>"};
  const SUB_PATTERNS = [
    [/lumbar|cushion|pillow|bolster|floor cushion/i,'i','square'],
    [/rocks|tasting flight|caddy|decanter|sleeve|wrap/i,'i','square'],
    [/bartender|service mat|bar mat|coaster mat/i,'i','square'],
    [/round\s*\d|square\s*\d|rectangle|valet|catchall|tray/i,'i','square'],
    [/wall-?mount|floor stand|tabletop|coffee-?table|magazine/i,'i','square'],["\\bbifold\\b","i","bifold"],["\\btrifold\\b","i","trifold"],["\\bmoney\\s*clip\\b","i","clip"],["^long\\b|\\blong\\b","i","long"],["^slim\\b|\\bslim\\s+(?:portfolio|4-card|wallet)?","i","slim"],["cascade","i","cascade"],["rfid","i","rfid"],["8-card","i","card8"],["4-card","i","card4"],["\\d+-?card","i","card4"],["single|^1-|1\\s*pocket","i","one"],["family|multi-key|3-pen|6-cable|6-watch|3-watch","i","multi"],["travel\\s*wallet|travel\\s*6","i","travel"],["zipper","i","zipper"],["magnetic|mag-?safe","i","magsafe"],["snap","i","snap"],["stitch|double-stitch","i","stitch"],["edge-?paint","i","edge"],["felt-?back","i","felt"],["heritage|vintage","i","vintage"],["embossed|engrav|debossed","i","engrave"],["backpack|laptop\\s*backpack","i","weekender"],["tote|shopper","i","shopper"],["bucket","i","bucket"],["messenger","i","messenger"],["duffel","i","duffel"],["weekender","i","weekender"],["crossbody","i","messenger"],["roll-?top|rolltop","i","rolltop"],["attach[ée]|brief","i","attache"],["garment","i","garment"],["carry-?on|cabin","i","cabinbag"],["trunk|steamer","i","trunk"],["menu|tasting","i","tasting"],["wine\\s*list|sommelier","i","bottle"],["bar\\s*program|cocktail","i","cocktail"],["kids","i","smile"],["banquet","i","banquet"],["check\\s*present","i","envelope"],["key\\s*card|hotel\\s*key|suite","i","smartkey"],["door\\s*plaque|privacy\\s*hanger|do\\s*not\\s*disturb","i","plaque"],["coaster","i","round"],["slipper\\s*pouch","i","drawstring"],["heated|sport|performance","i","sport"],["yacht\\s*helm|yacht|helm","i","yacht"],["marine|boat|nautical","i","boat"],["pilot|cabin\\s*crew|crew","i","crew"],["aircraft|jet|aviation|aero","i","plane"],["dealership","i","shop"],["glove-?box|owner\\s*manual","i","glovebox"],["smart-?key|key\\s*fob","i","smartkey"],["cushion","i","cushion"],["mount|wall-?mount","i","mount"],["iphone|samsung|phone\\s*case","i","phone"],["folio\\s*wallet","i","folio"],["cardholder\\s*back|card\\s*back","i","magsafe"],["airpods?\\b","i","airpod"],["magsafe","i","magsafe"],["laptop\\s*sleeve|13\"|14\"|16\"","i","tablet"],["ipad|tablet","i","tablet"],["pencil\\s*holster","i","pen"],["camera","i","camera"],["cable\\s*roll|cable","i","cable"],["watch\\s*roll|3-?watch|6-?watch","i","watch3"],["watch\\s*strap|apple\\s*watch|alligator\\s*strap|rally|bund","i","watch1"],["cufflink","i","cufflink"],["a4|letter|executive|3-ring","i","doc"],["junior\\s*pad|notepad","i","doc"],["journal|hard-?cover|hard\\s*cover","i","hardcover"],["sketch","i","sketch"],["pocket\\s*book|pocket\\s*journal|^pocket$","i","pocketbook"],["refillable|a5","i","refill"],["travelers?\\s*notebook|travelers?\\b","i","travelbk"],["desk\\s*pad|mouse\\s*pad|standard|single-?tone","i","felt"],["ergonomic|curved","i","ergo"],["xl\\b|extra\\s*large","i","xl"],["3-?pen|pen\\s*roll|pen\\s*case","i","threepen"],["document|conference\\s*folio|map\\s*case|contract\\s*sleeve","i","doc"],["card\\s*tray","i","snap"],["keychain|key\\s*loop|^loop$","i","loop"],["tassel","i","tassel"],["d-?ring","i","dring"],["hotel\\s*branded|branded\\s*suite|branded\\s*dealership|hotel","i","hotel"],["multi-key|multi\\s*key","i","multi"],["hook\\s*clip|hook","i","hook"],["belt|reversible|western\\s*buckle|buckle","i","belt"],["glove|driving\\s*glove|cashmere","i","snap"],["eyeglass|sunglass","i","round"],["cigar|humidor","i","cigar"],["whisky|decanter|rocks","i","whisky"],["dog|pet|collar|harness|lead","i","pet"],["golf|tournament|pro\\s*shop|player","i","golf"],["ring\\s*box|wedding\\s*ring|bearer","i","wedding"],["vow\\s*book|officiant","i","book"],["guest\\s*book|memorial","i","pulpit"],["photo\\s*album|studio\\s*archival|wedding\\s*heirloom","i","photo"],["award\\s*plaque|wall-?mounted|desk\\s*standing|engraving","i","trophy"],["lanyard","i","lanyard"],["belt-?clip|magnetic\\s*badge","i","badge"],["conference|summit|speaker\\s*gift|press\\s*kit","i","envelope"],["bible|pulpit|family","i","pulpit"],["diploma|honors|seal|doctorate|university","i","diploma"],["script|film|theater|tv\\s*writer","i","film"],["music|conductor|performer|choir|baton","i","music"],["saffiano|alligator|crocodile|python|ostrich","i","vintage"],["standard|classic|default","i","square"],["custom|bespoke|made-?to-?order","i","engrave"],["^large\\b","i","large"],["^medium\\b","i","medium"],["^mini|^small\\b","i","small"]];
  function iconForSub(name){ for(const [src,flags,key] of SUB_PATTERNS){ if(new RegExp(src,flags).test(name)) return key; } return "square"; }
  function subSvg(name){ const k=iconForSub(name); return '<svg viewBox="0 0 24 24" aria-hidden="true">'+(SUB_ICONS[k]||SUB_ICONS.square)+'</svg>'; }
    function slugForSub(s){return String(s).toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
    const SUB_PARENT_ALIASES={'whiskey-glass-holders':'whisky-glass-holders'};
    function subIcon(parentName,subName){
            let ps = slugForSub(parentName); ps = SUB_PARENT_ALIASES[ps]||ps; const ss = slugForSub(subName);
        const orig = window.GCB2B_ASSET_BASE+'gcb2b-sub-'+ps+'--'+ss+'-sm.webp';      /* 2048x2048 SEO original */
        const sm   = window.GCB2B_ASSET_BASE+'gcb2b-sub-'+ps+'--'+ss+'-sm.webp';   /* 256px display copy (~2KB) */
        /* Performance + Image SEO: the browser DOWNLOADS the tiny 256px copy to render the 72px icon
           (chosen via sizes), while the 2048x2048 original stays a srcset candidate so image search still
           indexes the high-res. loading=lazy + decoding=async, and drawers build their HTML only on open,
           so NONE of these load on initial page paint. Descriptive B2B alt for image SEO. The decorative
           SVG (aria-hidden inside subSvg) shows through if the image 404s (onerror removes the img). */
        const alt = subName+' '+parentName+', custom-branded oxblood leather, B2B wholesale by GENTCREATE (MOQ 25)';
        return '<span class="m23-sub-icon">'+subSvg(subName)+'<img class="m23-sub-photo" src="'+sm+'" srcset="'+sm+' 256w, '+orig+' 2048w" sizes="72px" width="72" height="72" alt="'+alt.replace(/"/g,'&quot;')+'" loading="lazy" decoding="async" onerror="this.remove()"></span>';
    }

  (function(){
    const burger=document.getElementById('navBurger');
    const drawer=document.getElementById('mobileDrawer');
    burger.addEventListener('click',()=>{
      const isOpen=drawer.classList.toggle('open');
      burger.classList.toggle('open',isOpen);
      burger.setAttribute('aria-expanded',String(isOpen));
      drawer.setAttribute('aria-hidden',String(!isOpen));
      document.body.style.overflow=isOpen?'hidden':'';
    });
    window.closeDrawer=function(){
      drawer.classList.remove('open');burger.classList.remove('open');
      burger.setAttribute('aria-expanded','false');drawer.setAttribute('aria-hidden','true');
      document.body.style.overflow='';
    };
  })();

  /* Header localization disclosure (Shopify Dawn Header__LocalizationForm parity): close on outside-click + Escape. */
  (function(){
    const loc=document.getElementById('headerLocale');
    if(!loc) return;
    document.addEventListener('click',e=>{ if(loc.open && !loc.contains(e.target)) loc.open=false; });
    document.addEventListener('keydown',e=>{ if(e.key==='Escape' && loc.open){ loc.open=false; const s=loc.querySelector('summary'); if(s) s.focus(); } });
  })();

  document.querySelectorAll('a[href^="#"]').forEach(a=>{
      a.addEventListener('click',e=>{
        const h=a.getAttribute('href');
        if(!h||h==='#'||h.length<2) return;
        let t=null; try{ t=document.querySelector(h); }catch(_){ return; }
        if(t){e.preventDefault();if(typeof closeDrawer==='function')closeDrawer();t.scrollIntoView({behavior:'smooth',block:'start'});}
      });
    });

  document.querySelectorAll('.m06-tab').forEach(tab=>{
    tab.addEventListener('click',()=>{
      const target=tab.dataset.tab;
      document.querySelectorAll('.m06-tab').forEach(t=>{t.classList.toggle('active',t===tab);t.setAttribute('aria-selected',String(t===tab));});
      document.querySelectorAll('.m06-pane').forEach(p=>p.classList.toggle('active',p.dataset.pane===target));
    });
  });

  // BUBBLE CAROUSEL ARROWS
  function scrollBubbles(btn,dir){
    const carousel=btn.closest('.m23-carousel');
    const strip=carousel.querySelector('.m23-bubbles');
    strip.scrollBy({left:dir*Math.min(280,strip.clientWidth*0.7),behavior:'smooth'});
  }
  function updateBubbleArrows(){
    document.querySelectorAll('.m23-carousel').forEach(c=>{
      const strip=c.querySelector('.m23-bubbles');
      const prev=c.querySelector('.m23-arrow.prev');
      const next=c.querySelector('.m23-arrow.next');
      if(!strip||!prev||!next)return;
      const overflow=strip.scrollWidth>strip.clientWidth+5;
      if(!overflow){prev.style.display='none';next.style.display='none';return;}
      prev.style.display='';next.style.display='';
      prev.disabled=strip.scrollLeft<=2;
      next.disabled=strip.scrollLeft+strip.clientWidth>=strip.scrollWidth-2;
    });
  }
  document.querySelectorAll('.m23-bubbles').forEach(s=>s.addEventListener('scroll',updateBubbleArrows,{passive:true}));
  window.addEventListener('resize',updateBubbleArrows);
  window.addEventListener('load',updateBubbleArrows);
  setTimeout(updateBubbleArrows,200);

  // INDUSTRY CAROUSEL
  function scrollIndustries(dir){
    const strip=document.getElementById('ind-strip');
    strip.scrollBy({left:dir*Math.min(300,strip.clientWidth*0.7),behavior:'smooth'});
  }

  /* v11.11 #4: dynamic industry-count word in heading */
  (function(){
    const ones=['Zero','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
    const tens=['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
    function spell(n){
      if(n<20) return ones[n];
      if(n<100){const t=Math.floor(n/10),o=n%10;return tens[t]+(o?'-'+ones[o]:'');}
      if(n<1000){const h=Math.floor(n/100),r=n%100;return ones[h]+' Hundred'+(r?' '+spell(r):'');}
      return String(n);
    }
    const strip=document.getElementById('ind-strip');
    const count=strip?strip.querySelectorAll('.ind-card').length:0;
    document.querySelectorAll('[data-ind-count-words]').forEach(el=>{if(count>0)el.textContent=spell(count);});
  })();

  // TESTIMONIAL SLIDER
  const m10Slider=document.getElementById('m10-slider')||document.createElement('div');
  const m10Dots=document.getElementById('m10-dots')||document.createElement('div');
  let m10Total=m10Slider.children.length;
  function buildM10Dots(){
    m10Dots.innerHTML='';
    const perView=Math.max(1,Math.round(m10Slider.clientWidth/(m10Slider.children[0]?.clientWidth+24||300)));
    const pages=Math.max(1,m10Total-perView+1);
    for(let i=0;i<pages;i++){
      const d=document.createElement('button');d.className='m10-dot'+(i===0?' active':'');d.type='button';d.setAttribute('aria-label','Go to testimonial '+(i+1));
      d.onclick=()=>{const card=m10Slider.children[i];if(card)m10Slider.scrollTo({left:card.offsetLeft-m10Slider.offsetLeft,behavior:'smooth'});};
      m10Dots.appendChild(d);
    }
  }
  function updateM10Dots(){
    const cardW=(m10Slider.children[0]?.clientWidth||300)+24;
    const idx=Math.round(m10Slider.scrollLeft/cardW);
    [...m10Dots.children].forEach((d,i)=>d.classList.toggle('active',i===idx));
  }
  function scrollTestimonials(dir){
    const cardW=(m10Slider.children[0]?.clientWidth||300)+24;
    m10Slider.scrollBy({left:dir*cardW,behavior:'smooth'});
  }
  m10Slider.addEventListener('scroll',updateM10Dots,{passive:true});
  window.addEventListener('resize',buildM10Dots);
  buildM10Dots();

  /* v13 fix: material picker, selector was '.qf-mat' but buttons are '.qf-material' (and dataset is data-material, not data-mat). Without this fix the entire material grid did nothing. */
    document.addEventListener('click', function(e){
      var b = e.target.closest && e.target.closest('.qf-material');
      if(!b) return;
      e.preventDefault();
      b.classList.toggle('active');
      b.setAttribute('aria-pressed', b.classList.contains('active') ? 'true' : 'false');
      var sel = [].map.call(document.querySelectorAll('.qf-material.active'), function(x){ return x.dataset.material || x.getAttribute('title') || ''; }).filter(Boolean);
      var matInput = document.getElementById('qf-material'); if(matInput) matInput.value = sel.join(', ');
      if(window.gcSetMaterials) window.gcSetMaterials(sel);
      /* Material selection flows ONLY into the Project Summary above (via qf-material); it is never stamped into the free-write "Anything else we should know" textarea. */
    });

  /* v13: custom qty dropdown (replaces native <select> popup so width matches button & styling matches form) */
    (function(){
      document.querySelectorAll('[data-qf-select]').forEach(function(wrap){
        var btn=wrap.querySelector('.qf-select-btn'), menu=wrap.querySelector('.qf-select-menu'),
            valEl=wrap.querySelector('[data-qf-val]'), hidden=wrap.querySelector('input[type=hidden]');
        if(!btn||!menu||!valEl||!hidden) return;
        function open(){menu.hidden=false;btn.setAttribute('aria-expanded','true');}
        function close(){menu.hidden=true;btn.setAttribute('aria-expanded','false');}
        btn.addEventListener('click',function(e){e.stopPropagation();menu.hidden?open():close();});
        menu.querySelectorAll('[role=option]').forEach(function(li){
          li.addEventListener('click',function(){
            menu.querySelectorAll('.selected').forEach(function(s){s.classList.remove('selected');});
            li.classList.add('selected');
            valEl.innerHTML=li.dataset.label;
            hidden.value=li.dataset.val;
            hidden.dispatchEvent(new Event('change',{bubbles:true}));
            close();btn.focus();
          });
        });
        document.addEventListener('click',function(e){if(!wrap.contains(e.target))close();});
        btn.addEventListener('keydown',function(e){
          if(e.key==='Enter'||e.key===' '){e.preventDefault();menu.hidden?open():close();}
          else if(e.key==='Escape'){close();}
          else if(e.key==='ArrowDown'&&!menu.hidden){e.preventDefault();var f=menu.querySelector('li');if(f)f.focus();}
        });
      });
      var qty=document.getElementById('qf-qty');
      if(qty){qty.addEventListener('change',function(){
        var w=document.getElementById('qf-qty-custom-wrap');
        if(w)w.style.display=qty.value==='custom'?'block':'none';
      });}
    })();

  /* v13.1+ Project Summary auto-builder. Reads qf-colors, qf-material, hidden-product-interest, quantity select, and writes a visual preview into the summary block. */
    /* GCB2B-I18N:js — empty states and button labels come from the section markup (translatable settings), never from this file. */
    function gcQfEmptyHTML(el){ if(!el) return ''; if(typeof el.__gcEmpty!=='string') el.__gcEmpty=el.innerHTML; return el.__gcEmpty; }
    function buildProjectSummary(){
      ['qf-summary-colors','qf-summary-materials','qf-summary-products','qf-summary-quantity'].forEach(function(id){ gcQfEmptyHTML(document.getElementById(id)); });
      var colorsRaw = (document.getElementById('qf-colors') || {}).value || '';
      var colors = colorsRaw.split(',').filter(Boolean);
      var colorsEl = document.getElementById('qf-summary-colors');
      if (colorsEl){
        if (colors.length){
          var sumNames = (typeof uniqueColorNames === 'function') ? uniqueColorNames(colors) : colors.map(function(h){ return (typeof nameForHex==='function')?nameForHex(h.trim()):h.trim().toUpperCase(); });
          sumNames = sumNames.map(function(x){ return window.gcColorName ? window.gcColorName(x) : x; });
          colorsEl.innerHTML = colors.map(function(h, i){
            h = h.trim();
            var hexUC = h.toUpperCase();
            var nm = sumNames[i] || hexUC;
            /* dedup may have appended the hex to the name for a clash; don't show it twice */
            var nameHasHex = nm.toUpperCase().indexOf(hexUC) !== -1;
            return '<span class="qf-summary-chip"><span class="qf-summary-chip-sw" style="background:' + h + '"></span><span>' + nm + '</span>' + (nameHasHex ? '' : '<span class="qf-summary-chip-hex">' + hexUC + '</span>') + '</span>';
          }).join('');
        } else {
          colorsEl.innerHTML = gcQfEmptyHTML(colorsEl);
        }
      }
      var mat = (document.getElementById('qf-material') || {}).value || '';
      var matEl = document.getElementById('qf-summary-materials');
      if (matEl){
        var mats = mat.split(', ').filter(Boolean);
        matEl.innerHTML = mats.length ? mats.map(function(m){ return '<span class="qf-summary-chip">' + gcT(m) + '</span>'; }).join('') : gcQfEmptyHTML(matEl);
      }
      var prod = (document.getElementById('hidden-product-interest') || {}).value || '';
      var prodEl = document.getElementById('qf-summary-products');
      if (prodEl){
        prodEl.innerHTML = prod ? prod.split('; ').map(function(p){ return '<span class="qf-summary-chip">' + window.gcTParts(p) + '</span>'; }).join('') : gcQfEmptyHTML(prodEl);
      }
      var qtyLabel = ((document.querySelector('[data-qf-val]') || {}).textContent || '').trim();
      var qtyEl = document.getElementById('qf-summary-quantity');
      if (qtyEl){
        qtyEl.innerHTML = qtyLabel ? ('<span class="qf-summary-chip">' + qtyLabel.replace(/[–—]/g, '‑') + '</span>') : gcQfEmptyHTML(qtyEl);
      }
    }
    document.addEventListener('input', function(e){
      if (e.target.matches('#qf-colors, #qf-material, #hidden-product-interest, .qf-color-hex')){
        buildProjectSummary();
      }
    });
    document.addEventListener('change', function(e){
      if (e.target.matches('#qf-colors, #qf-material, #hidden-product-interest, #qf-qty')){
        buildProjectSummary();
      }
    });
    document.addEventListener('click', function(e){
      if (e.target.closest('.qf-color-add, .qf-color-tag-rm, .qf-material, .qf-select-menu li')){
        setTimeout(buildProjectSummary, 50);
      }
    });
    if (document.readyState === 'complete') buildProjectSummary();
    else window.addEventListener('load', buildProjectSummary);

  /* v13.2 Quote feedback: after any CTA injects a value, refresh the summary, smooth-scroll
     to it, and flash the affected row in brand gold so the buyer SEES what was added. */
    function quoteFlash(keys){
      try{ buildProjectSummary(); }catch(e){}
      var tgt=document.getElementById('qf-summary')||document.getElementById('quote-form');
      if(tgt){ try{ tgt.scrollIntoView({behavior:'smooth',block:'center'}); }catch(e){ tgt.scrollIntoView(); } }
      setTimeout(function(){
        (keys&&keys.length?keys:['products']).forEach(function(k){
          var row=document.querySelector('.qf-summary-row[data-key="'+k+'"]'); if(!row) return;
          row.classList.remove('qf-row-flash'); void row.offsetWidth; row.classList.add('qf-row-flash');
          var chips=row.querySelector('.qf-summary-chips'); if(!chips) return;
          [].forEach.call(chips.querySelectorAll('.qf-summary-chip'),function(c){ c.classList.remove('qf-chip-pop'); void c.offsetWidth; c.classList.add('qf-chip-pop'); });
          var old=chips.querySelector('.qf-added-flag'); if(old&&old.parentNode){ old.parentNode.removeChild(old); }
          var flag=document.createElement('span');
          flag.className='qf-summary-chip qf-added-flag'; flag.setAttribute('role','status');
          flag.innerHTML='<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 13l4 4L19 7"/></svg>'+gcT('Added to quote');
          chips.appendChild(flag);
          clearTimeout(row._qfT);
          row._qfT=setTimeout(function(){
            row.classList.remove('qf-row-flash');
            var f=chips.querySelector('.qf-added-flag');
            if(f){ f.classList.add('out'); setTimeout(function(){ if(f.parentNode) f.parentNode.removeChild(f); },360); }
          },2600);
        });
      },540);
    }
    window.quoteFlash=quoteFlash;
    function setQuoteProduct(name){ if(window.gcAddToQuote) window.gcAddToQuote(name); }
    window.setQuoteProduct=setQuoteProduct;

  /* v13.3 GENTCREATE Quote Cart — every "add to quote" action accumulates a line into a
     draggable, dismissible floating tracker (no scroll). Clicking it opens the popup
     summary; "Review & order" writes every line into the on-page Wholesale Contact Form,
     then scrolls + flashes it. */
    (function(){
      var KEY='gc-quote-items', POSK='gc-quote-cart-pos';
      var items=[]; try{ items=JSON.parse(localStorage.getItem(KEY)||'[]')||[]; }catch(e){ items=[]; }
      var materials=[]; var colors=[];
      var root=document.createElement('div'); root.id='gc-qc'; root.className='gc-qc'; root.setAttribute('aria-live','polite');
      root.innerHTML=
        '<div class="gc-qc-panel" id="gc-qc-panel" role="dialog" aria-label="'+gcT('Your quote list')+'" hidden>'
        +'<div class="gc-qc-head" id="gc-qc-head">'
        +'<span class="gc-qc-title">'+gcT('Your Quote')+'</span><span class="gc-qc-badge" id="gc-qc-badge"></span>'
        +'<button type="button" class="gc-qc-x" id="gc-qc-min" aria-label="'+gcT('Minimise quote list')+'" title="'+gcT('Minimise quote list')+'"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 9l6 6 6-6"/></svg></button></div>'
        +'<ul class="gc-qc-list" id="gc-qc-list"></ul>'
        +'<div class="gc-qc-foot"><button type="button" class="gc-qc-clear" id="gc-qc-clear">'+gcT('Clear all')+'</button>'
        +'<button type="button" class="gc-qc-order" id="gc-qc-order">'+gcT('Review & order →')+'</button></div></div>'
        +'<button type="button" class="gc-qc-pill" id="gc-qc-pill" aria-label="'+gcT('Open your quote list')+'">'
        +'<svg class="gc-qc-ico" viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h16l-1.2 11.2a2 2 0 0 1-2 1.8H7.2a2 2 0 0 1-2-1.8L4 7Z"/><path d="M8.5 7V6a3.5 3.5 0 0 1 7 0v1"/></svg>'
        +'<span class="gc-qc-pill-label">'+gcT('Your quote')+'</span><span class="gc-qc-count" id="gc-qc-count">0</span></button>';
      (document.body||document.documentElement).appendChild(root);

      var panel=root.querySelector('#gc-qc-panel'), pill=root.querySelector('#gc-qc-pill'),
          listEl=root.querySelector('#gc-qc-list'), countEl=root.querySelector('#gc-qc-count'),
          badgeEl=root.querySelector('#gc-qc-badge');

      function save(){ try{ localStorage.setItem(KEY, JSON.stringify(items)); }catch(e){} syncProductInterest(); }
      function syncProductInterest(){ var pi=document.getElementById('hidden-product-interest'); if(!pi) return; var v=items.join('; '); if(pi.value===v) return; pi.value=v; try{ pi.dispatchEvent(new Event('input',{bubbles:true})); }catch(e){} }
      function esc(s){ return String(s).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];}); }
      /* "Product <dash> Sub" splitter — dash matched by CODE POINT (en U+2013 / em U+2014) so it always
         matches what selectSub() emits, regardless of source-file dash encoding. */
      var GC_SUBSEP=new RegExp('^(.*?) [\\u2013\\u2014] (.*)$');
      function render(){
        var total=items.length+materials.length+colors.length;
        countEl.textContent=total;
        badgeEl.textContent=total+(total===1?' item':' items');
        /* Group product items by their head (the text before " — "): all sub-types of one product collect
           into a SINGLE section instead of one row each (e.g. Keychains · Loop / Tassel / D-ring). Bundles,
           custom requests and bare products with no sub-type stay as a simple one-line row. Items remain
           stored flat in `items`, so the form still receives the full per-line detail. */
        var prodOrder=[], prodMap={};
        items.forEach(function(label,i){
          var m=label.match(GC_SUBSEP);
          var head = m ? m[1] : label;
          var sub  = m ? m[2] : null;
          if(!prodMap[head]){ prodMap[head]={entries:[]}; prodOrder.push(head); }
          prodMap[head].entries.push({i:i, sub:sub});
        });
        var rows=prodOrder.map(function(head){
          var entries=prodMap[head].entries;
          var hasSub=entries.some(function(e){return e.sub!==null;});
          if(!hasSub && entries.length===1){
            return '<li class="gc-qc-item"><span class="gc-qc-item-dot" aria-hidden="true"></span><span class="gc-qc-item-label">'+esc(head)+'</span><button type="button" class="gc-qc-item-rm" data-i="'+entries[0].i+'" aria-label="Remove '+esc(head)+'">&#10005;</button></li>';
          }
          var chips=entries.map(function(e){
            var txt=e.sub!==null?e.sub:'Standard';
            return '<span class="gc-qc-prod-chip">'+esc(txt)+'<button type="button" class="gc-qc-prod-x" data-i="'+e.i+'" aria-label="Remove '+esc(head)+' '+esc(txt)+'">&#10005;</button></span>';
          }).join('');
          return '<li class="gc-qc-item gc-qc-prodgrp"><span class="gc-qc-item-dot" aria-hidden="true"></span><span class="gc-qc-item-label"><span class="gc-qc-mat-head">'+esc(head)+' &middot; '+entries.length+'</span><span class="gc-qc-prod-subs">'+chips+'</span></span><button type="button" class="gc-qc-item-rm" data-rm-grp="'+esc(head)+'" aria-label="Remove all '+esc(head)+'">&#10005;</button></li>';
        }).join('');
        if(materials.length){
          rows+='<li class="gc-qc-item gc-qc-mat"><span class="gc-qc-item-dot" aria-hidden="true"></span><span class="gc-qc-item-label"><span class="gc-qc-mat-head">'+esc(gcT('Leathers'))+' &middot; '+materials.length+'</span><span class="gc-qc-mat-list">'+materials.map(esc).join(' &middot; ')+'</span></span><button type="button" class="gc-qc-item-rm" data-rm-mat="1" aria-label="'+esc(gcT('Remove all leathers'))+'">&#10005;</button></li>';
        }
        if(colors.length){
          var colNames=(window.uniqueColorNames?window.uniqueColorNames(colors):colors.map(function(c){return window.nameForHex?window.nameForHex(c):String(c).toUpperCase();}));
          colNames=colNames.map(function(x){ return window.gcColorName ? window.gcColorName(x) : x; });
          var colChips=colors.map(function(c,i){
            var nm=colNames[i]||String(c).toUpperCase();
            var hexUC=String(c).toUpperCase();
            var ttl=nm+(nm.toUpperCase().indexOf(hexUC)!==-1?'':' '+hexUC)+' - tap to add or edit colours';
            return '<button type="button" class="gc-qc-col-chip" data-coli="'+i+'" title="'+esc(ttl)+'"><span class="gc-qc-col-dot" style="background:'+esc(c)+'"></span><span class="gc-qc-col-nm">'+esc(nm)+'</span></button>';
          }).join('');
          colChips += '<button type="button" class="gc-qc-col-chip gc-qc-col-more" aria-label="'+esc(gcT('Add or edit brand colours'))+'" title="'+esc(gcT('Add or edit your brand colours'))+'">'+esc(gcT('+ More'))+'</button>';
          rows+='<li class="gc-qc-item gc-qc-mat gc-qc-col"><span class="gc-qc-item-dot" aria-hidden="true"></span><span class="gc-qc-item-label"><span class="gc-qc-mat-head">'+esc(gcT('Colors'))+' &middot; '+colors.length+'</span><span class="gc-qc-col-sw">'+colChips+'</span></span><button type="button" class="gc-qc-item-rm" data-rm-col="1" aria-label="'+esc(gcT('Remove all colors'))+'">&#10005;</button></li>';
        }
        if(total){
          var qtyLabel=((document.querySelector('[data-qf-val]')||{}).textContent||'').replace(/[–—‑]/g,'-').trim();
          if(qtyLabel){ rows+='<li class="gc-qc-item gc-qc-mat gc-qc-qty"><span class="gc-qc-item-dot" aria-hidden="true"></span><span class="gc-qc-item-label"><span class="gc-qc-mat-head">'+esc(gcT('Quantity'))+'</span><span class="gc-qc-mat-list">'+esc(qtyLabel)+'</span></span><span class="gc-qc-qty-caret" aria-hidden="true">&#9662;</span></li>'; }
        }
        listEl.innerHTML = total ? rows : '<li class="gc-qc-empty">'+esc(gcT('No items yet. Add a bundle, product, leather or colour to start your quote.'))+'</li>';
        root.classList.toggle('gc-qc-has', total>0);
        document.documentElement.classList.toggle('gc-quoting', total>0);
      }
      function flip(){ if(!innerHeight||!innerWidth) return; var r=pill.getBoundingClientRect(); root.classList.toggle('gc-qc--down', r.top<innerHeight/2); root.classList.toggle('gc-qc--right', (r.left+r.width/2)>innerWidth/2); }
      function openPanel(){ panel.hidden=false; root.classList.add('gc-qc-open'); flip(); }
      function closePanel(){ panel.hidden=true; root.classList.remove('gc-qc-open'); }
      function bump(){ pill.classList.remove('gc-qc-bump'); void pill.offsetWidth; pill.classList.add('gc-qc-bump'); }

      function addItem(label){
        label=(label||'').trim(); if(!label) return;
        if(items.indexOf(label)===-1){ items.push(label); save(); }
        render(); root.classList.remove('gc-qc-hidden'); openPanel(); bump();
      }
      window.gcAddToQuote=addItem; syncProductInterest();
      (function(){ var mi=document.getElementById('qf-material'); if(mi&&mi.value) materials=mi.value.split(', ').filter(Boolean); })();
      window.gcSetMaterials=function(arr){ materials=(arr||[]).filter(Boolean); render(); if(materials.length){ root.classList.remove('gc-qc-hidden'); bump(); } };
      (function(){ var ci=document.getElementById('qf-colors'); if(ci&&ci.value) colors=ci.value.split(',').filter(Boolean); })();
      window.gcSetColors=function(arr){ colors=(arr||[]).filter(Boolean); render(); if(colors.length){ root.classList.remove('gc-qc-hidden'); bump(); } };

      /* Deep-link from a cart row to the matching picker in the form: close the cart, smooth-scroll to
         the picker, briefly pulse it, and open/focus its control (reuses the form's gcFocusPicker). This
         replaces the old in-cart mini-menus so buyers edit selections in ONE place (the form) and the cart
         can never drift out of sync with it. */
      function gotoPicker(key){
        closePanel();
        if(window.gcFocusPicker){ window.gcFocusPicker(key); }
        else { var f=document.getElementById('quote-form'); if(f){ try{ f.scrollIntoView({behavior:'smooth'}); }catch(e){ f.scrollIntoView(); } } }
        var pid = key==='colors' ? 'qf-color-track' : key==='quantity' ? 'qf-qty-btn' : 'qf-material-grid';
        var pe = document.getElementById(pid);
        if(pe && key==='colors'){ pe = pe.closest('.qf-color-pad') || pe; }
        if(pe){ pe.classList.remove('gc-mat-pulse'); void pe.offsetWidth; pe.classList.add('gc-mat-pulse'); setTimeout(function(){ pe.classList.remove('gc-mat-pulse'); },1600); }
      }
      listEl.addEventListener('click',function(e){
        /* Remove a single product sub-type chip (× inside a grouped product section). */
        var px=e.target.closest('.gc-qc-prod-x');
        if(px){ var pxi=+px.getAttribute('data-i'); if(pxi>=0){ items.splice(pxi,1); save(); render(); if(!items.length&&!materials.length&&!colors.length) closePanel(); } return; }
        /* Remove (×) buttons take priority so a click on a row's × always removes, never deep-links. */
        var rm=e.target.closest('.gc-qc-item-rm');
        if(rm){
          /* whole-product group × — drop every item under this product head */
          if(rm.getAttribute('data-rm-grp')){
            var grp=rm.getAttribute('data-rm-grp');
            items=items.filter(function(label){ var mm=label.match(GC_SUBSEP); var h=mm?mm[1]:label; return h!==grp; });
            save(); render(); if(!items.length&&!materials.length&&!colors.length) closePanel();
            return;
          }
          if(rm.getAttribute('data-rm-mat')){
            [].forEach.call(document.querySelectorAll('.qf-material.active'),function(x){ x.classList.remove('active'); x.setAttribute('aria-pressed','false'); });
            var mi=document.getElementById('qf-material'); if(mi) mi.value='';
            if(typeof buildProjectSummary==='function') buildProjectSummary();
            materials=[]; render(); if(!items.length&&!materials.length&&!colors.length) closePanel();
            return;
          }
          if(rm.getAttribute('data-rm-col')){
            if(window.gcClearColors) window.gcClearColors(); else { var ci=document.getElementById('qf-colors'); if(ci) ci.value=''; colors=[]; render(); }
            if(typeof buildProjectSummary==='function') buildProjectSummary();
            if(!items.length&&!materials.length&&!colors.length) closePanel();
            return;
          }
          var i=+rm.getAttribute('data-i'); if(i>=0){ items.splice(i,1); save(); render(); if(!items.length&&!materials.length&&!colors.length) closePanel(); }
          return;
        }
        /* A colour chip (or the Colours row body) jumps to the colour picker to add / edit more — it no
           longer removes the colour. Per-colour removal lives in the picker; the row × clears them all. */
        if(e.target.closest('.gc-qc-col-chip') || e.target.closest('.gc-qc-col')){ gotoPicker('colors'); return; }
        /* The Quantity row opens the real quantity selector dropdown. */
        if(e.target.closest('.gc-qc-qty')){ gotoPicker('quantity'); return; }
        /* The Leathers row jumps to the leather picker. */
        if(e.target.closest('.gc-qc-mat:not(.gc-qc-col):not(.gc-qc-qty)')){ gotoPicker('materials'); return; }
      });
      root.querySelector('#gc-qc-clear').addEventListener('click',function(){
        if(!confirm('Clear your entire quote? This removes all products, leathers and colours.')) return;
        items=[]; save();
        [].forEach.call(document.querySelectorAll('.qf-material.active'),function(x){ x.classList.remove('active'); x.setAttribute('aria-pressed','false'); });
        var mi=document.getElementById('qf-material'); if(mi) mi.value=''; materials=[];
        if(window.gcClearColors) window.gcClearColors(); else { var ci=document.getElementById('qf-colors'); if(ci) ci.value=''; colors=[]; }
        if(typeof buildProjectSummary==='function') buildProjectSummary();
        render(); closePanel();
      });
      root.querySelector('#gc-qc-min').addEventListener('click',function(e){ e.stopPropagation(); closePanel(); });

      root.querySelector('#gc-qc-order').addEventListener('click',function(){
        if(!items.length && !materials.length && !colors.length) return;
        if(items.length){
          var pi=document.getElementById('hidden-product-interest'); if(pi) pi.value=items.join('; ');
          var msg=document.getElementById('qf-msg');
          if(msg && !msg.value.trim()){ msg.value='I\'d like a wholesale quote for:\n'+items.map(function(it,i){return '  '+(i+1)+'. '+it;}).join('\n')+'\n\nPlease confirm volume pricing and lead time.'; }
        }
        closePanel();
        var keys=[]; if(items.length)keys.push('products'); if(materials.length)keys.push('materials'); if(colors.length)keys.push('colors');
        if(typeof quoteFlash==='function'){ quoteFlash(keys.length?keys:['products']); }
        else { var f=document.getElementById('quote-form'); if(f) f.scrollIntoView({behavior:'smooth'}); }
      });

      /* v13.4 drag removed — cart stays docked; pill click toggles the panel */
      flip();
      window.addEventListener('resize', flip);
      pill.addEventListener('click', function(e){ if(e.target.closest('.gc-qc-dismiss')) return; panel.hidden ? openPanel() : closePanel(); });
      document.addEventListener('click', function(e){ if(e.target.closest('[data-qf-select] [role=option]')){ setTimeout(render, 60); } });

      render();
    })();

  /* v13.1+ Project Summary deep-links. Clicking a summary row scrolls to that picker and opens/focuses it so the buyer can edit the corresponding selection without hunting the form. */
    (function(){
      function focusRow(key){
        var anchor, openFn;
        if (key === 'colors'){
          anchor = document.getElementById('qf-color-track');
          openFn = function(){ try{ anchor && anchor.focus({preventScroll:true}); }catch(e){} };
        } else if (key === 'materials'){
          anchor = document.getElementById('qf-material-grid');
          openFn = function(){
            var first = anchor && (anchor.querySelector('.qf-material.active') || anchor.querySelector('.qf-material'));
            try{ first && first.focus({preventScroll:true}); }catch(e){}
          };
        } else if (key === 'products'){
          anchor = document.getElementById('hidden-product-interest');
          openFn = function(){ try{ anchor && anchor.focus({preventScroll:true}); }catch(e){} };
        } else if (key === 'quantity'){
          anchor = document.getElementById('qf-qty-btn');
          openFn = function(){
            var btn = document.getElementById('qf-qty-btn');
            if (btn && btn.getAttribute('aria-expanded') !== 'true') btn.click();
          };
        }
        if (!anchor) return;
        /* Scroll anchor into the viewport center so the picker has room for its dropdown / chip rows below. */
        try { anchor.scrollIntoView({behavior:'smooth', block:'center'}); }
        catch(e) { anchor.scrollIntoView(); }
        /* Open / focus after the smooth-scroll settles. 450ms is comfortably past Safari's default scroll duration. */
        setTimeout(function(){ openFn(); try{ anchor.classList.add('gcb2b-pulse'); setTimeout(function(){ anchor.classList.remove('gcb2b-pulse'); }, 1400); }catch(e){} }, 450);
      }
      /* Shared so the floating quote cart's rows can deep-link to the same pickers (colors / materials / quantity / products). */
      try{ window.gcFocusPicker = focusRow; }catch(_){}
      document.addEventListener('click', function(e){
        var row = e.target.closest && e.target.closest('.qf-summary-row');
        if (!row) return;
        /* Don't hijack clicks on chips/buttons that may live inside the row in future iterations. */
        if (e.target.closest('a, button:not(.qf-summary-row), input, select, textarea')) return;
        e.preventDefault();
        focusRow(row.getAttribute('data-key'));
      });
      document.addEventListener('keydown', function(e){
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var row = e.target.closest && e.target.closest('.qf-summary-row');
        if (!row) return;
        e.preventDefault();
        focusRow(row.getAttribute('data-key'));
      });
    })();

  /* v13: multi-color brand list, Add this color button collects up to 5 hex values into a hidden input. The qf-msg textarea stays free-writing only, it never gets auto-stamped — the selection chain (colors + products + material + quantity) renders into qf-summary above instead. */
    (function(){
      var addBtn=document.getElementById('qf-color-add'),
          hexIn=document.getElementById('qf-color'),
          list=document.getElementById('qf-color-list'),
          hidden=document.getElementById('qf-colors');
      var MAX=5;
      if(!addBtn||!hexIn||!list||!hidden) return;
      function render(){
        var arr=(hidden.value||'').split(',').filter(Boolean);
        var taken=arr.map(function(c){return c.toLowerCase();});
        list.innerHTML=arr.map(function(h,i){
          return '<span class="qf-color-tag"><span class="qf-color-tag-sw" style="background:'+h+'"></span><span class="qf-color-tag-hex">'+h.toUpperCase()+'</span><button type="button" class="qf-color-tag-rm" data-i="'+i+'" aria-label="Remove '+h.toUpperCase()+'">&times;</button></span>';
        }).join('');
        list.hidden=arr.length===0;
        addBtn.disabled=arr.length>=MAX;
        addBtn.textContent=arr.length>=MAX?(addBtn.getAttribute('data-gc-max-label')||'').replace('[n]',MAX):(addBtn.getAttribute('data-gc-full-label')||addBtn.textContent);
        /* Hide preset pills that the user has already added so they cannot be re-added. Removing a color from the list re-shows its preset. */
        document.querySelectorAll('.qf-color-preset').forEach(function(btn){
          var h=(btn.dataset.hex||'').toLowerCase();
          btn.hidden=h && taken.indexOf(h)!==-1;
        });
        if(window.gcSetColors) window.gcSetColors(arr);
      }
      addBtn.addEventListener('click',function(){
        var v=(hexIn.value||'').trim().toLowerCase();
        if(!/^#?[0-9a-f]{6}$/.test(v))return;
        if(v.charAt(0)!=='#')v='#'+v;
        var arr=(hidden.value||'').split(',').filter(Boolean);
        if(arr.length>=MAX)return;
        if(arr.indexOf(v)===-1)arr.push(v);
        hidden.value=arr.join(',');
        render();
      });
      list.addEventListener('click',function(e){
        var b=e.target.closest('.qf-color-tag-rm');if(!b)return;
        var arr=(hidden.value||'').split(',').filter(Boolean);
        arr.splice(parseInt(b.dataset.i,10),1);
        hidden.value=arr.join(',');
        render();
      });
      window.gcClearColors=function(){ hidden.value=''; render(); };
      window.gcAddColor=function(hex){ hex=(hex||'').trim().toLowerCase(); if(!/^#?[0-9a-f]{6}$/.test(hex))return false; if(hex.charAt(0)!=='#')hex='#'+hex; var a=(hidden.value||'').split(',').filter(Boolean); if(a.length>=MAX)return false; if(a.indexOf(hex)===-1)a.push(hex); hidden.value=a.join(','); render(); return true; };
      window.gcRemoveColor=function(hex){ var a=(hidden.value||'').split(',').filter(Boolean); var i=a.indexOf((hex||'').toLowerCase()); if(i===-1)i=a.indexOf(hex); if(i!==-1){ a.splice(i,1); hidden.value=a.join(','); render(); } };
      render();
    })();

  /* v13: file upload (multiple files, drag & drop, image thumbnails, 25 MB cap each) */
    (function(){
      var input=document.getElementById('qf-files'),
          list=document.getElementById('qf-upload-list'),
          drop=document.getElementById('qf-upload-wrap'),
          trigger=document.getElementById('qf-upload-trigger');
      if(!input||!list||!trigger) return;
      var files=[]; var MAX_SIZE=25*1024*1024;
      function fmt(b){return b>1048576?(b/1048576).toFixed(1)+' MB':Math.max(1,Math.ceil(b/1024))+' KB';}
      function thumb(f){
        if(f.type.indexOf('image/')!==0) return '<span class="qf-upload-icon" aria-hidden="true">📄</span>';
        if(!f._thumbUrl){try{f._thumbUrl=URL.createObjectURL(f);}catch(_){return '<span class="qf-upload-icon" aria-hidden="true">🖼</span>';}}
        return '<span class="qf-upload-thumb" style="background-image:url('+f._thumbUrl+')" aria-hidden="true"></span>';
      }
      function render(){
        list.innerHTML=files.map(function(f,i){
          return '<div class="qf-upload-item">'+thumb(f)+'<span class="qf-upload-name" title="'+(f.name.replace(/"/g,'&quot;'))+'">'+f.name+'</span><span class="qf-upload-size">'+fmt(f.size)+'</span><button type="button" class="qf-upload-rm" data-i="'+i+'" aria-label="Remove '+f.name.replace(/"/g,'&quot;')+'">&times;</button></div>';
        }).join('');
        list.hidden=files.length===0;
        trigger.querySelector('span').textContent=files.length?gcT('Add more files ({n} attached)').replace('{n}',files.length):gcT('Drop files here or click to upload');
      }
      function add(fl){
        Array.prototype.forEach.call(fl,function(f){if(f.size<=MAX_SIZE)files.push(f);});
        render();
      }
      trigger.addEventListener('click',function(){input.click();});
      input.addEventListener('change',function(){add(input.files);input.value='';});
      list.addEventListener('click',function(e){
        var b=e.target.closest('.qf-upload-rm');if(!b)return;
        var i=parseInt(b.dataset.i,10);
        if(files[i]&&files[i]._thumbUrl){try{URL.revokeObjectURL(files[i]._thumbUrl);}catch(_){}}
        files.splice(i,1);render();
      });
      if(drop){
        ['dragenter','dragover'].forEach(function(ev){drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.add('drag');});});
        ['dragleave','dragend'].forEach(function(ev){drop.addEventListener(ev,function(e){e.preventDefault();drop.classList.remove('drag');});});
        drop.addEventListener('drop',function(e){e.preventDefault();drop.classList.remove('drag');if(e.dataTransfer&&e.dataTransfer.files)add(e.dataTransfer.files);});
      }
    })();

    // v10: build CATALOG from DOM (the prior var was referenced but never declared)
    const SUBS_BY_PRODUCT = {
      "Wallets": [
        "Bifold",
        "Trifold",
        "Long",
        "Slim",
        "Money Clip"
      ],
      "Bifold Wallets": [
        "8-Slot Classic",
        "With Coin Pocket",
        "RFID-Blocking",
        "Full-Grain Heritage"
      ],
      "Money Clips": [
        "Bifold + Clip",
        "Card-Wing + Clip",
        "Spring-Steel Clip"
      ],
      "Phone Cases": [
        "Full-Pattern MagSafe",
        "Rubber-Edge",
        "Full-Pattern + Strap",
        "Rubber-Edge + Strap"
      ],
      "Exotic Phone Cases": [
        "Nile Crocodile",
        "Python",
        "Alligator"
      ],
      "Cigar Cases": [
        "2-Cigar Travel",
        "3-Cigar Travel",
        "Cedar-Lined"
      ],
      "Menu Covers": [
        "Casebound 2-View",
        "Trifold",
        "Wine List Cover",
        "Check Presenter"
      ],
      "Watch Rolls": [
        "1-Watch",
        "3-Watch",
        "Alcantara-Lined"
      ],
      "Golf Head Covers": [
        "Driver",
        "Fairway Wood",
        "Hybrid (Numbered Set)",
        "Blade Putter Headcover",
        "Mallet Putter Headcover",
        "Iron Set (1-9 Wrap)"
      ],
      "Golf Accessories": [
        "Bag Tee Holder",
        "Pencil & Scorecard Holder",
        "Yardage Book Cover",
        "Divot Tool Holder",
        "Glove Caddy",
        "Range Finder Case",
        "Ball Marker Wallet",
        "Bag Tag",
        "Towel Loop",
        "Cigar Holder (Cart-Mount)"
      ],
      "Tennis Racket Covers": [
        "Single Racket Cover",
        "Two-Racket Cover",
        "Ball Can Sleeve (3-can)",
        "Overgrip Wrap",
        "String Wallet",
        "Court Bag Strap"
      ],
      "Equestrian Helmet Cases": [
        "Skull-Cap Case",
        "Dressage Case",
        "Hunting Case",
        "Crop Holder",
        "Bridle Hanger",
        "Stirrup Leather Wrap",
        "Show Number Holder",
        "Hoof Pick Holder",
        "Bit Pouch"
      ],
      "Padel Racket Covers": [
        "Single Racket Cover",
        "Two-Racket Cover",
        "Pickleball Paddle Cover",
        "Ball Can Sleeve",
        "Grip Wrap",
        "Scorecard Holder"
      ],
      "Golf Bags": [
        "Tour Staff Bag",
        "Cart Bag",
        "Stand Bag",
        "Carry / Pencil Bag",
        "Sunday Bag",
        "Travel Cover (Hard-Shell)",
        "Travel Cover (Soft Padded)",
        "Shoe Bag",
        "Valuables Pouch",
        "Range / Shag Bag"
      ],
      "Tennis Bags": [
        "3-Pack Racket Bag",
        "6-Pack Racket Bag",
        "9-Pack Racket Bag",
        "12-Pack Pro Bag",
        "Court Backpack",
        "Tour Duffel",
        "Sling Crossbody",
        "Shoe Compartment Add-On",
        "Stringing Tool Pouch",
        "Wristband &amp; Grip Wallet"
      ],
      "Padel Bags": [
        "Single Racket Sleeve",
        "Two-Racket Bag",
        "Three-Racket Tour Bag",
        "Court Backpack",
        "Padel Duffel",
        "Shoe Compartment Add-On",
        "Ball Can Sleeve (3-can)",
        "Grip &amp; Overgrip Wallet"
      ],
      "Card Holders": [
        "Slim 4-card",
        "Bifold 8-card",
        "Cascade",
        "RFID-blocking"
      ],
      "Passport Holders": [
        "Single",
        "Family 4-pack",
        "Travel Wallet"
      ],
      "Bags": [
        "Tote",
        "Crossbody",
        "Weekender",
        "Duffel",
        "Messenger",
        "Shopper",
        "Bucket"
      ],
      "Backpacks": [
        "City",
        "Laptop 15”",
        "Travel 40L",
        "Mini",
        "Roll-top",
        "Convertible"
      ],
      "Briefcases": [
        "Attaché",
        "Slim portfolio",
        "Triple-gusset",
        "Roller",
        "Pilot"
      ],
      "Suitcases": [
        "Carry-on",
        "Cabin trunk",
        "Steamer",
        "Vintage hard-side",
        "Garment trunk"
      ],
      "Luggage Tags": [
        "Slip-in",
        "Buckle",
        "RFID privacy"
      ],
      "Toiletry Pouches": [
        "Dopp kit",
        "Hanging organizer",
        "Watch roll-style"
      ],
      "Padfolios": [
        "A4 letter",
        "Junior",
        "Zippered",
        "Executive 3-ring"
      ],
      "Journals": [
        "A5 refillable",
        "Pocket",
        "Travelers",
        "Hard-cover bound",
        "Sketch"
      ],
      "Desk Pads": [
        "Single-tone",
        "Double-stitch",
        "Edge-painted",
        "Felt-backed"
      ],
      "Mouse Pads": [
        "Standard",
        "XL",
        "Ergonomic curved"
      ],
      "Pen Cases": [
        "Single",
        "3-pen",
        "Roll",
        "Magnetic flip"
      ],
      "Document Holders": [
        "Conference folio",
        "Contract sleeve",
        "Map case"
      ],
      "Card Trays": [
        "Snap",
        "Magnetic",
        "Stitched",
        "Reception desk"
      ],
      "Restaurant Menu Covers": [
        "Tasting menu",
        "Wine list",
        "Bar program",
        "Kids menu",
        "Banquet pad"
      ],
      "Check Presenters": [
        "Slim",
        "Pocketed",
        "Magnetic close",
        "Branded debossed"
      ],
      "Hotel Key Card Holders": [
        "Single pocket",
        "Branded suite",
        "RFID safe"
      ],
      "Room Number Plaques": [
        "Door",
        "Privacy hanger",
        "Suite identifier"
      ],
      "Do-Not-Disturb Tags": [
        "Reversible",
        "Heritage stitched"
      ],
      "Coasters": [
        "Round 4\"",
        "Square 4\"",
        "Hex",
        "Stitched edge",
        "Embossed monogram"
      ],
      "Slipper Pouches": [
        "Drawstring",
        "Snap-flap"
      ],
      "Wine List Covers": [
        "Sommelier folio",
        "Tasting flight cards"
      ],
      "Steering Wheel Covers": [
        "Standard",
        "Sport",
        "Heated-compatible",
        "Yacht helm"
      ],
      "Key Fob Holders": [
        "Slim",
        "Smart-key wallet",
        "Branded dealership"
      ],
      "Owner Manual Wallets": [
        "Glove-box",
        "Service-history pouch"
      ],
      "Yacht Drink Holders": [
        "Mounted",
        "Cushion-set"
      ],
      "Aircraft Headphone Cases": [
        "Pilot",
        "Crew",
        "Passenger"
      ],
      "Phone Cases": [
        "iPhone",
        "Samsung",
        "Folio wallet",
        "MagSafe",
        "Cardholder back"
      ],
      "Watch Straps": [
        "Apple Watch",
        "Vintage tan",
        "Alligator",
        "Rally",
        "Bund"
      ],
      "Watch Rolls": [
        "1-watch",
        "3-watch",
        "Travel 6-watch",
        "Cufflink combo"
      ],
      "AirPods Cases": [
        "Pro",
        "Max",
        "Hook clip"
      ],
      "Laptop Sleeves": [
        "13”",
        "14”",
        "16”",
        "Padded with strap"
      ],
      "iPad Folios": [
        "Mini",
        "Air",
        "Pro 11",
        "Pro 13",
        "Pencil holster"
      ],
      "Camera Straps": [
        "Wrist",
        "Neck",
        "Shoulder",
        "Sling"
      ],
      "Cable Rolls": [
        "3-cable",
        "6-cable",
        "With pen loop"
      ],
      "Keychains": [
        "Loop",
        "Tassel",
        "D-ring",
        "Hotel branded",
        "Multi-key fob"
      ],
      "Belts": [
        "Dress",
        "Casual",
        "Reversible",
        "Western buckle",
        "Crocodile"
      ],
      "Gloves": [
        "Driving",
        "Dress",
        "Cashmere-lined",
        "Touchscreen"
      ],
      "Eyeglass Cases": [
        "Hard-shell",
        "Slip",
        "Magnetic"
      ],
      "Cigar Cases": [
        "3-finger",
        "5-finger",
        "Travel humidor wrap"
      ],
      "Whisky Glass Holders": [
        "Single rocks",
        "Double rocks",
        "Tasting flight",
        "Cigar caddy combo"
      ],
      "Dog Collars & Leads": [
        "Collar",
        "Standard lead",
        "Training lead",
        "Harness"
      ],
      "Golf Scorecard Covers": [
        "Player",
        "Tournament",
        "Pro shop branded"
      ],
      "Ring Boxes": [
        "Single",
        "Double",
        "Bearer pouch"
      ],
      "Vow Books": [
        "His & Hers set",
        "Single",
        "Officiant"
      ],
      "Guest Books": [
        "Wedding",
        "Corporate event",
        "Gallery",
        "Memorial"
      ],
      "Photo Albums": [
        "4x6 100",
        "5x7 80",
        "Wedding heirloom",
        "Studio archival"
      ],
      "Conference Folios": [
        "Branded summit",
        "Speaker gift",
        "Press kit"
      ],
      "Badge Holders": [
        "Lanyard",
        "Belt-clip",
        "Magnetic"
      ],
      "Award Plaques": [
        "Wall-mounted",
        "Desk standing",
        "Frame with engraving"
      ],
      "Bible Covers": [
        "Pocket",
        "Standard",
        "Family pulpit",
        "Heirloom hand-bound"
      ],
      "Diploma Covers": [
        "University",
        "Doctorate",
        "Honors with seal"
      ],
      "Script Binders": [
        "Film",
        "Theater",
        "Television writers room"
      ],
      "Sheet Music Folios": [
        "Conductor",
        "Performer",
        "Choir"
      ],
      "Wine Tasting Logs": [
        "Sommelier",
        "Vineyard owner",
        "Collector"
      ],
      "Pillows": [
        "Lumbar 14×24",
        "Square 18×18",
        "Square 22×22",
        "Bolster",
        "Floor cushion"
      ],
      "Bar Mats": [
        "Bartender 18×24",
        "Service mat 12×16",
        "Coaster mat 8×12"
      ],
      "Catchall Trays": [
        "Round 6\"",
        "Square 6\"",
        "Rectangle 8×12",
        "Valet with divider"
      ],
      "Decanter Sleeves": [
        "Wine 750ml",
        "Whiskey decanter",
        "Champagne magnum",
        "Gift box pair"
      ],
      "Magazine Racks": [
        "Wall-mount",
        "Floor stand",
        "Tabletop holder",
        "Coffee-table tray"
      ]
    };
    function gcAsk(n){ return String(n == null ? '' : n).split('&').join('&amp;').split('"').join('&quot;'); }
    const CATALOG = (function(){
      const out = [];
      document.querySelectorAll('.m23-cat').forEach(catEl => {
        const id = catEl.dataset.cat;
        const products = [];
        catEl.querySelectorAll('.m23-bubble').forEach(b => {
          const n = b.dataset.prod;
          products.push({
            n,
            status: b.dataset.status || 'planned',
            subs: SUBS_BY_PRODUCT[n] || [],
            page: '/pages/' + (b.dataset.page || (n.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'')))
          });
        });
        out.push({ id, products });
      });
      return out;
    })();


      /* gcb2b: link-index real-page targets (scripts/patch-linkindex-targets.mjs). The hub's "By Product" column sent every
         entry to the in-page quote form because the mockup's product pages were never built. The
         entries below now have a real page, so they link to it and carry NO data-gcb2b-ask — the
         subnav's ask handler must not swallow them. Paths come from the Liquid data attribute on
         #m12-by-product, rendered through snippets/gcb2b-url, so they stay locale-correct. */
      window.gcb2bPageFor = window.gcb2bPageFor || (function(){
        var MAP = {"Card Holders":"cardholders","Zip Cardholders":"cardholders","Vertical Cardholders":"cardholders","Business Card Cases":"cardholders","Bifold Wallets":"wallets","Money Clips":"wallets","Travel Wallets":"wallets","Zip-Around Wallets":"wallets","Phone Cases":"phone-cases","Exotic Phone Cases":"phone-cases","MagSafe Wallets":"phone-cases"};
        var urls = null;
        return function(name){
          if (urls === null) {
            var el = document.getElementById('m12-by-product');
            if (!el) return '';
            try { urls = JSON.parse(el.getAttribute('data-gcb2b-pages') || '{}'); } catch(e) { urls = {}; }
          }
          var key = MAP[String(name == null ? '' : name).trim()];
          return (key && urls[key]) || '';
        };
      })();
      /* v10.8 dynamic menu population from CATALOG (auto-updates as products are added) */
      function renderProductMenus(){
        const allProducts = [];
        CATALOG.forEach(c => c.products.forEach(p => allProducts.push({n:p.n, page:p.page, cat:c.id, status:p.status})));
        /* desktop mega menu */
        const megaCol = document.querySelector('.b2b-mega-col[data-auto="by-product"]');
        if(megaCol){
          const grouped = {};
          CATALOG.forEach(c => { grouped[c.id] = c.products; });
          const catNames = {wallets:'Wallets & Cardholders', tech:'Phone & Tech', keys:'Keys, Tags & Travel', bags:'Bags & Weekenders', office:'Office & Desk', hospitality:'Hospitality & Front-of-House', leisure:'Cigars, Watches & Leisure', golf:'Golf & Country Club', events:'Wedding, Events & Keepsakes'};
          let h = '<h5>'+gcT('By Product Type')+'</h5>';
          Object.keys(grouped).forEach(catId => {
            h += '<div style="margin-top:10px;font-size:9.5px;font-weight:700;letter-spacing:2px;text-transform:uppercase;color:#9a9a9a">'+gcT(catNames[catId]||catId)+'</div>';
            grouped[catId].slice(0,5).forEach(p => {
              h += '<a href="#quote-form" data-gcb2b-ask="'+gcAsk(p.n)+'" data-gcb2b-kind="product">'+gcT(p.n)+(p.status==='planned'?' <small>'+gcT('(coming)')+'</small>':'')+'</a>';
            });
          });
          h += '<a href="#products" style="margin-top:10px;color:var(--gc-gold-3);font-weight:600">'+gcT('View all {n} products →').replace('{n}',allProducts.length)+'</a>';
          megaCol.innerHTML = h;
        }
        /* m12 by-product column */
        const m12 = document.querySelector('#m12-by-product ul');
        if(m12){
          m12.innerHTML = allProducts.map(p =>
            (window.gcb2bPageFor(p.n) ? '<li><a href="'+window.gcb2bPageFor(p.n)+'"><span>'+gcT(p.n)+'</span></a></li>' : '<li><a href="#quote-form" data-gcb2b-ask="'+gcAsk(p.n)+'" data-gcb2b-kind="product"><span>'+gcT(p.n)+'</span></a></li>')
          ).join('');
        }
        /* mobile drawer "Solutions" by-product list */
        const drawerSolutions = document.querySelector('.mobile-drawer .m-section .m-section-body');
        if(drawerSolutions && drawerSolutions.innerHTML.includes('By Product')){
          const before = drawerSolutions.innerHTML.split('<h6>By Product</h6>')[0];
          const afterBlock = drawerSolutions.innerHTML.split('<h6>Capabilities</h6>')[1];
          let mid = '<h6>By Product</h6>';
          allProducts.forEach(p => {
            mid += '<a href="#quote-form" data-gcb2b-ask="'+gcAsk(p.n)+'" data-gcb2b-kind="product">'+gcT(p.n)+'</a>';
          });
          drawerSolutions.innerHTML = before + mid + (afterBlock ? '<h6>Capabilities</h6>'+afterBlock : '');
        }
        /* update hero count + search placeholder dynamically */
        const cnt = allProducts.length;
        const search = document.getElementById('bubble-search');
        if(search){ search.placeholder = 'Search '+cnt+'+ products (e.g. wallet, menu cover, watch roll, leather pants…)'; }
      }
      try{ renderProductMenus(); }catch(e){ console.warn('menu render', e); }

      /* v13.6 m23 leather chips now SELECT a leather for the quote (the chip-click
         listener marks it + records window.gcM23Leather, then the readout's "Add
         color & leather to quote" button adds it). No products focus / scroll. */
      function filterByLeather(term){ /* no-op: leather selection no longer jumps to the product grid */ }
      function jumpToHexPicker(){
        const sec = document.getElementById('quote-form');
        if(sec){ sec.scrollIntoView({behavior:'smooth',block:'start'}); }
        setTimeout(() => {
          const hex = document.querySelector('.qf-color-hex, #qf-color-hex, input[type="color"]');
          if(hex){ hex.focus(); hex.scrollIntoView({behavior:'smooth',block:'center'}); }
        }, 600);
      }

      /* v10.8 #9 bundle helpers */
      function useBundle(name, productList, minQty){
        gcAddToQuote('Bundle: ' + name);
      }
      function startCustomBundle(){
        gcAddToQuote('Custom bundle (describe specs in form notes)');
      }

      /* v13.1+ Pricing summary on desktop: visible header strip, NOT a toggle. Click is blocked above 980px so the card never collapses. Mobile (<=980px) keeps native accordion behavior. */
      (function blockPricingSummaryToggleOnDesktop(){
        var mq = window.matchMedia('(min-width: 981px)');
        document.querySelectorAll('.m07-card > summary.m07-summary-mobile').forEach(function(s){
          s.addEventListener('click', function(e){
            if (mq.matches){ e.preventDefault(); e.stopPropagation(); }
          });
          s.addEventListener('keydown', function(e){
            if (mq.matches && (e.key === 'Enter' || e.key === ' ')){ e.preventDefault(); e.stopPropagation(); }
          });
        });
      })();

      /* (m24 spotlight removed, bulb fixture now lives only in the hero) */

      /* v13.1+ Sticky CTA appears only after the user has scrolled past the m01 hero, keeps the hero clean and high-impact. */
      (function hideStickyInHero(){
        var hero = document.getElementById('m01Hero');
        var cta = document.querySelector('.gc-sticky-cta');
        if (!hero || !cta || !('IntersectionObserver' in window)) return;
        cta.classList.add('is-hidden-in-hero');
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (entry.isIntersecting) cta.classList.add('is-hidden-in-hero');
            else cta.classList.remove('is-hidden-in-hero');
          });
        }, { threshold: 0.05 });
        io.observe(hero);
      })();

      /* v13.1+ FAQ (m11), click on the answer body also collapses the item so the user can dismiss without having to scroll back up to the summary. Links/buttons inside the body remain fully clickable (no collapse). */
      (function m11BodyToggle(){
        document.querySelectorAll('.m11-item').forEach(function(item){
          var body = item.querySelector('.m11-item-body');
          if (!body) return;
          body.addEventListener('click', function(e){
            if (e.target.closest('a, button, input, textarea, select, label')) return;
            item.open = false;
          });
        });
      })();

      /* v13.1+ Signature Hardbox: auto-rotate the 3D viewer briefly when the section first scrolls into view, then hand control to the user. Once the user interacts (mouse, touch, wheel, key), rotation is permanently disabled so it never fights the user. */
      (function autoRotateM25(){
        var v = document.querySelector('.m25-viewer');
        if (!v || !('IntersectionObserver' in window)) return;
        var userTook = false;
        var stopRotate = function(){
          if (userTook) return;
          userTook = true;
          v.removeAttribute('auto-rotate');
          v.removeAttribute('auto-rotate-delay');
        };
        ['pointerdown','wheel','touchstart','keydown'].forEach(function(ev){
          v.addEventListener(ev, stopRotate, { passive: true });
        });
        var io = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if (entry.isIntersecting && !userTook){
              v.setAttribute('auto-rotate', '');
              v.setAttribute('auto-rotate-delay', '0');
              v.setAttribute('rotation-per-second', '18deg');
              io.unobserve(v);
            }
          });
        }, { threshold: 0.30 });
        io.observe(v);
      })();
  

      /* v10.9 #5: industry context panel */
      const IND_CONTEXT = {
        restaurant:{name:'Restaurants',anchor:'Menu covers',blurb:'A4 menu covers and matching check presenters in debossed full-grain, the front-of-house leather signature. Most restaurants reorder twice a year as menus rotate.',moq:'25 covers',lead:'4-5 wk',clients:'2,400+ restaurants'},
        hotel:{name:'Hotels & Resorts',anchor:'Key card holders',blurb:'Key card sleeves, suite amenity sets, do-not-disturb tags, and welcome folios. Boutique hotels start at 200 rooms; international groups order 2,000-10,000 rooms per refurb cycle.',moq:'100 sets',lead:'5-7 wk',clients:'180+ hotels'},
        bar:{name:'Bars & Clubs',anchor:'Coasters & bar mats',clients:'600+ venues',blurb:'Boxed coasters in sets of 6, bartender service mats, bottle service kits, and VIP membership wallets. The branding tier most asked for is foil + deboss combo.',moq:'50 coasters',lead:'4 wk'},
        spa:{name:'Spas & Wellness',anchor:'Treatment menus',blurb:'Soft-touch treatment menus, slipper pouches, key fobs, and gift card sleeves in vegetable-tanned bridle. The aesthetic is quiet luxury, not loud branding.',moq:'25 menus',lead:'5 wk',clients:'320+ spas'},
        yacht:{name:'Yachting & Marine',anchor:'Helm & locker wraps',blurb:'Custom helm wraps, locker covers, log binders, and crew gift kits in marine-grade saffiano. Every yacht is bespoke, measurements come from the captain or shipyard.',moq:'1 vessel',lead:'8-12 wk',clients:'90+ yachts'},
        jet:{name:'Private Jets & Aviation',anchor:'Cabin amenity sets',blurb:'Cabin amenity boxes, headset cases, log book covers, and crew gift sets. FAA-friendly fire-treated leather available on request.',moq:'1 aircraft',lead:'6-8 wk',clients:'45+ operators'},
        car:{name:'Auto Dealerships',anchor:'Owner manual portfolios',blurb:'Owner manual portfolios in matching dealership leather, key fobs, sales-handover folios, and service-loaner welcome kits. Color-matched to brand within ±Pantone 2.',moq:'50 folios',lead:'5 wk',clients:'140+ dealerships'},
        house:{name:'Real Estate',anchor:'Closing gift sets',blurb:'Closing gift sets, catchall tray + key fob + leather-bound home inspection binder, foil-stamped with the new owner\'s name and closing date.',moq:'25 sets',lead:'4 wk',clients:'900+ agents'},
        scales:{name:'Law Firms',anchor:'Padfolios & document holders',blurb:'A5 padfolios, court binder covers, business card cases, and partner-promotion gift sets in conservative full-grain. Discreet branding only.',moq:'25 padfolios',lead:'4 wk',clients:'380+ firms'},
        finance:{name:'Finance & Wealth Management',anchor:'Client onboarding kits',blurb:'Welcome wallets, signed-statement portfolios, and HNW client gift trios in oxblood saffiano. Compliance-friendly minimal branding standard.',moq:'50 kits',lead:'4-5 wk',clients:'420+ firms'},
        tech:{name:'Technology',anchor:'Tech-sleeve bundles',blurb:'Laptop sleeves, mouse pads, AirPods cases, and conference badge wallets in vegan or recycled leather. Sustainability story matters as much as the product.',moq:'100 units',lead:'4 wk',clients:'1,200+ companies'},
        health:{name:'Healthcare & Pharma',anchor:'CME/conference kits',blurb:'Conference padfolios, badge holders, and physician-recognition gifts. Antimicrobial-treated leather available for clinical settings.',moq:'50 kits',lead:'4-6 wk',clients:'260+ orgs'},
        edu:{name:'Universities & Education',anchor:'Diploma covers & alumni gifts',blurb:'Diploma portfolios, alumni-board gifting trios, and donor-recognition leather-bound books. Custom embossed crest is the universal tier-1 ask.',moq:'100 covers',lead:'5-6 wk',clients:'180+ universities'},
        sports:{name:'Sports & Athletics',anchor:'Trophy & locker tags',blurb:'Player welcome packs, leather locker tags, captain\'s arm bands, and championship presentation cases for franchises and college programs.',moq:'25 packs',lead:'5 wk',clients:'80+ teams'},
        religious:{name:'Religious Organizations',anchor:'Bible & hymnal covers',blurb:'Custom bible/hymnal covers, clergy padfolios, and milestone presentation boxes. Conservative finishes, deep familial archive of crests.',moq:'25 covers',lead:'5 wk',clients:'140+ congregations'},
        wedding:{name:'Wedding & Event Planners',anchor:'Guest welcome boxes',blurb:'Welcome-box trios for destination weddings, catchall + luggage tag + welcome card sleeve. Turnaround can compress to 3 weeks for events under 100 guests.',moq:'25 sets',lead:'3-5 wk',clients:'520+ planners'},
        camera:{name:'Photography & Video',anchor:'Camera straps & album boxes',blurb:'Custom-stitched camera straps, lens-pouch sets, and luxury wedding-album presentation boxes. Hand-burnished edges, full-grain only.',moq:'25 straps',lead:'4-6 wk',clients:'300+ studios'},
        gov:{name:'Government & Embassies',anchor:'Diplomatic gift sets',blurb:'State-visit gift sets, embassy padfolios, and diplomatic credential cases. Conservative palette, optional national-crest debossing handled in-house.',moq:'25 sets',lead:'6-8 wk',clients:'40+ ministries'},
        military:{name:'Military & Veterans',anchor:'Service awards',blurb:'Years-of-service award sets, retirement gifting, and veteran-org padfolios. Insignia and unit-crest debossing matched to provided art files.',moq:'50 sets',lead:'5 wk',clients:'120+ units & VSOs'},
        music:{name:'Music Industry',anchor:'Tour & label gift kits',blurb:'Tour-crew gift kits, A&R presentation folios, and artist welcome boxes. Bold finishes (foiled metallic, oxblood saffiano) most requested.',moq:'25 kits',lead:'4 wk',clients:'80+ labels & mgmt'},
        film:{name:'Film, TV & Theater',anchor:'Script binders',blurb:'Custom script binders by production, leather-bound prop pieces, and end-of-wrap crew gifts. Per-production branding handled per call sheet.',moq:'25 binders',lead:'3-5 wk',clients:'60+ productions'},
        wine:{name:'Wineries & Distilleries',anchor:'Decanter sleeves & wine portfolios',blurb:'Decanter sleeves, magnum wraps, wine-list covers, and trade-show folios. Cellar tour leather books and tasting-note portfolios for clubs.',moq:'25 sleeves',lead:'4-5 wk',clients:'190+ wineries'},
        watch:{name:'Watch & Jewelry Brands',anchor:'Watch rolls & travel pouches',blurb:'Watch rolls (1-6 capacity), travel pouches, and brand-anchor catchall trays for boutiques. Pillow-stitched interiors, suede inner lining standard.',moq:'25 rolls',lead:'5-6 wk',clients:'70+ maisons'},
        fashion:{name:'Fashion & Luxury Brands',anchor:'Private-label collections',blurb:'Full private-label production runs, wallets, card holders, and small accessories under your label. From 200 unit pilot to 5,000 unit annual programs.',moq:'200 units',lead:'10-14 wk',clients:'30+ labels'}
      };
      function showIndustryContext(key, opts){
        opts = opts || {};
        const ctx = IND_CONTEXT[key];
        const panel = document.getElementById('ind-context');
        if(!ctx || !panel) return;
        document.getElementById('ind-context-name').textContent = gcT(ctx.name);
        document.getElementById('ind-context-icon').textContent = '◆';
        document.getElementById('ind-context-blurb').textContent = gcT(ctx.blurb);
        const tags = [];
        if(ctx.anchor) tags.push('<span class="ind-context-tag">'+gcT('Anchor')+', <strong>'+gcT(ctx.anchor)+'</strong></span>');
        if(ctx.moq) tags.push('<span class="ind-context-tag">'+gcT('MOQ')+', <strong>'+gcT(ctx.moq)+'</strong></span>');
        if(ctx.lead) tags.push('<span class="ind-context-tag">'+gcT('Lead')+', <strong>'+gcT(ctx.lead)+'</strong></span>');
        if(ctx.clients) tags.push('<span class="ind-context-tag"><strong>'+gcT(ctx.clients)+'</strong></span>');
        document.getElementById('ind-context-meta').innerHTML = tags.join('');
        panel.classList.remove('updated'); void panel.offsetWidth; panel.classList.add('updated');
        document.querySelectorAll('.ind-card').forEach(c => { var on = c.dataset.ind===key; c.classList.toggle('active', on); if(on) centerIndCard(c); });
        if(opts.center){
          const strip = document.getElementById('ind-strip');
          const card = strip && strip.querySelector('.ind-card[data-ind="'+key+'"]');
          if(strip && card){
            const target = card.offsetLeft - (strip.clientWidth - card.clientWidth)/2;
            strip.scrollTo({left: Math.max(0, target), behavior:'smooth'});
          }
        }
      }
      document.addEventListener('click', function(e){
        const card = e.target.closest('.ind-card[data-ind]');
        if(card){
          e.preventDefault();
          showIndustryContext(card.dataset.ind, {center:true});
        }
      });
      /* on scroll-snap, surface the centered industry's context automatically */
      (function(){
        const strip = document.getElementById('ind-strip');
        if(!strip) return;
        let t;
        strip.addEventListener('scroll', () => {
          clearTimeout(t);
          t = setTimeout(() => {
            const r = strip.getBoundingClientRect();
            const cx = r.left + r.width/2;
            let best=null, bestD=Infinity;
            strip.querySelectorAll('.ind-card[data-ind]').forEach(c => {
              const cr = c.getBoundingClientRect();
              const d = Math.abs(cr.left + cr.width/2 - cx);
              if(d<bestD){ bestD=d; best=c; }
            });
            if(best) showIndustryContext(best.dataset.ind);
          }, 140);
        }, {passive:true});
      })();

      /* v10.9 #1+#2: leather strip arrow scroll */
      
      (function syncFaqTitle(){
        var sec = document.querySelector('section.m11-section') || document.querySelector('section[aria-labelledby="faq-h"]');
        var t = document.querySelector('[data-faq-title]');
        if(!sec || !t) return;
        var n = sec.querySelectorAll('.m11-item, details').length;
        var words = {1:'One',2:'Two',3:'Three',4:'Four',5:'Five',6:'Six',7:'Seven',8:'Eight',9:'Nine',10:'Ten',11:'Eleven',12:'Twelve'};
        if (n !== 8) t.textContent = gcT('{n} Questions Buyers Ask Before Their First Order').replace('{n}', gcT(words[n] || String(n)));
      })();
  
    
      /* Generate a leather-appropriate friendly name from any hex. Uses HSL to determine the family, then layers a lightness modifier. */
      function nameForHex(hex){
        var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if(!m) return hex;
        var n = parseInt(m[1], 16);
        var r = ((n>>16)&255)/255, g = ((n>>8)&255)/255, b = (n&255)/255;
        var max = Math.max(r,g,b), min = Math.min(r,g,b);
        var l = (max+min)/2;
        var s = (max === min) ? 0 : (l > 0.5 ? (max-min)/(2-max-min) : (max-min)/(max+min));
        var h = 0;
        if (max !== min){
          var d = max - min;
          if (max === r) h = (g-b)/d + (g<b ? 6 : 0);
          else if (max === g) h = (b-r)/d + 2;
          else h = (r-g)/d + 4;
          h *= 60;
        }
        var L = Math.round(l*100), S = Math.round(s*100);
        /* Near-neutral: name by lightness alone */
        if (S < 12){
          if (L < 10)  return 'Onyx';
          if (L < 25)  return 'Espresso';
          if (L < 45)  return 'Slate Grey';
          if (L < 65)  return 'Stone';
          if (L < 85)  return 'Sand';
          return 'Ivory';
        }
        /* Hue family. The deep-red core (h<20) is split by SATURATION, not just hue: a vivid pure
           blood-red (#480C0C, S71) and a greyed oxblood (#3C1A14, S50) sit at almost the same hue
           yet read as different colours, so saturation is what separates Crimson / Oxblood / Mahogany.
           The rest of the leather-heavy red-brown region keeps its finer hue bands. */
        var fam;
        if (h < 20 || h >= 350){
          if (S >= 60)      fam = 'Crimson';   // vivid, pure red
          else if (S >= 38) fam = 'Oxblood';   // classic muted dark red
          else              fam = 'Mahogany';  // greyed, brownish red
        }
        else if (h < 30)  fam = 'Mahogany';
        else if (h < 40)  fam = 'Chestnut';
        else if (h < 50)  fam = 'Cognac';
        else if (h < 62)  fam = 'Amber';
        else if (h < 78)  fam = 'Brass';
        else if (h < 95)  fam = 'Olive';
        else if (h < 150) fam = 'Forest';
        else if (h < 195) fam = 'Marine';
        else if (h < 232) fam = 'Navy';
        else if (h < 262) fam = 'Indigo';
        else if (h < 290) fam = 'Aubergine';
        else if (h < 318) fam = 'Plum';
        else fam = 'Burgundy';
        /* Lightness modifier — finer steps, adds a 'Black' tier below 'Midnight' and a 'Dark'/'Light'
           step so two dark hides at different L (e.g. L6 vs L12) no longer collapse to one name. */
        var mod;
        if      (L < 8)  mod = 'Black';
        else if (L < 16) mod = 'Midnight';
        else if (L < 26) mod = 'Deep';
        else if (L < 38) mod = 'Dark';
        else if (L < 52) mod = '';
        else if (L < 66) mod = 'Soft';
        else if (L < 80) mod = 'Light';
        else             mod = 'Pale';
        return mod ? mod + ' ' + fam : fam;
      }
      /* Lightweight HSL extractor (0-360, 0-100, 0-100) for the de-dup tone logic below. */
      function _hexHSL(hex){
        var m = /^#?([0-9a-f]{6})$/i.exec(hex || ''); if(!m) return null;
        var n = parseInt(m[1], 16);
        var r=((n>>16)&255)/255, g=((n>>8)&255)/255, b=(n&255)/255;
        var max=Math.max(r,g,b), min=Math.min(r,g,b), l=(max+min)/2;
        var s=(max===min)?0:(l>0.5?(max-min)/(2-max-min):(max-min)/(max+min));
        var h=0; if(max!==min){ var d=max-min;
          if(max===r) h=(g-b)/d+(g<b?6:0); else if(max===g) h=(b-r)/d+2; else h=(r-g)/d+4; h*=60; }
        return { h:h, s:Math.round(s*100), l:Math.round(l*100) };
      }
      /* Guarantee the colours shown in a list never display the same NAME twice. Two hides that land
         on the same base name are separated FIRST by tone (saturation: Vivid / Rich / Muted / Dusty),
         which reads naturally as a real swatch name; only genuinely indistinguishable hides (same tone
         too) fall back to the hex code so every chip is still unambiguous. */
      function uniqueColorNames(arr){
        var base = arr.map(function(c){ return nameForHex(String(c).trim()); });
        var out = base.slice();
        var groups = {}; base.forEach(function(nm,i){ (groups[nm]=groups[nm]||[]).push(i); });
        Object.keys(groups).forEach(function(nm){
          var g = groups[nm]; if(g.length < 2) return;            // no clash → leave as-is
          var hsls = g.map(function(i){ return _hexHSL(arr[i]) || {h:0,s:0,l:0}; });
          var ss = hsls.map(function(x){ return x.s; });
          var dS = Math.max.apply(null, ss) - Math.min.apply(null, ss);
          if(dS >= 14){                                           // meaningfully different vividness → tone words
            g.forEach(function(idx, k){
              var s = hsls[k].s;
              var word = s>=66 ? 'Vivid' : s>=46 ? 'Rich' : s>=30 ? 'Muted' : 'Dusty';
              out[idx] = word + ' ' + nm;
            });
          }
          /* Resolve any labels that are STILL identical within this group (same tone bucket, or no
             tone split applied) by appending the hex to those specific chips. */
          var seen = {}; g.forEach(function(idx){ (seen[out[idx]]=seen[out[idx]]||[]).push(idx); });
          Object.keys(seen).forEach(function(key){
            if(seen[key].length > 1){
              seen[key].forEach(function(idx){
                var hx = String(arr[idx]).trim().toUpperCase(); if(hx.charAt(0) !== '#') hx = '#' + hx;
                out[idx] = base[idx] + ' ' + hx;
              });
            }
          });
        });
        return out;
      }
      /* Hand-written, non-templated buyer-incentivizing one-liner per color.
         Each line frames the colour in terms of who buys it and what story it tells , 
         B2B procurement, not retail copywriting. Custom hex picks fall back to a
         family-level blurb based on the generated nameForHex() result. */
      var COLOR_BLURBS = {
        'Burgundy':      'Old-money quiet, the favourite of family banks, private clubs, and gift programs that don’t need to shout.',
        'Black':         'The boardroom default, reads serious from the back row, ages like a Patek strap.',
        'Forest Green':  'Country-club green, library green, racing green, chosen by buyers who don’t want to look new.',
        'Navy':          'Diplomatic posture, the colour every law firm and finance house picks when in doubt.',
        'Brown':         'Atelier classic, the more it’s carried, the more it tells the brand story.',
        'Oxblood':       'A century of executive credibility, compressed into one deep claret.',
        'Espresso':      'The morning-meeting colour, quiet, alert, never out of place.',
        'Onyx':          'Architectural black. Edges crisp, debossing reads beautifully, never fades to grey.',
        'Cognac Dark':   'The most-ordered shade from auto-dealership programs, handed across the desk with the keys.',
        'Tobacco':       'Smoky, lived-in warmth, picked when the brand wants to feel inherited, not bought.',
        'Mocha':         'Soft, approachable luxury, the spa, the wellness retreat, the hospitality kit.',
        'Mahogany':      'Library-panel warmth, chosen by wealth managers and law-school alumni gift programs.',
        'Black Cherry':  'Almost-black with a quiet warm bloom, luxury without the volume.',
        'Chocolate':     'Confectioner-rich, photogenic on every surface, the foodservice and patisserie default.',
        'Walnut':        'Furniture-grade tone, at home with brass, marble, and slow-aged interiors.',
        'Chestnut':      'Equestrian heritage, saddle-shop classic, immediately legible as quality.',
        'Coffee':        'Workhorse warm-brown, the most forgiving across foil, deboss, and laser engraving.',
        'Maroon':        'Collegiate, banked, considered, the alumni and members-only colour.',
        'Wine':          'Sommelier red. Cellar books, tasting logs, and restaurant menus made for it.',
        'Bordeaux':      'French wine country in a hide, heritage hospitality programs gravitate here.',
        'Crimson Dark':  'Cardinal-rich, ceremonial, the choice of universities, awards, and graduations.',
        'Plum':          'Editorial-magazine purple, fashion houses and beauty brands love it on iPhone cases.',
        'Aubergine':     'Couture nightshade, slightly off-black, deeply photogenic, never seen on a mass product.',
        'Sapphire':      'Watchmaker blue, discreet enough for finance, expressive enough for jewellery.',
        'Indigo':        'Ink-stained intellect, chosen by publishers, law libraries, and rare-book curators.',
        'Slate':         'Architect grey, Brutalist, MoMA-shop, beautiful next to brushed steel.',
        'Charcoal':      'Quiet uniform grey, the safest non-black for corporate programs that prefer not to commit.',
        'Graphite':      'Pencil-dark monochrome, pairs flawlessly with silver foil and minimal branding.',
        'Gunmetal':      'Aerospace-cool, chosen by jet-card programs and luxury automotive launches.',
        'Pewter':        'Subdued metallic feel without the metal, modern, neutral, gallery-friendly.',
        'Hunter Green':  'Old-club hunting tradition, dialled to a 2026 office, the firm-name colour.',
        'Bottle Green':  'Apothecary green, perfumeries and heritage spirits brands ask for this one by name.',
        'Racing Green':  'British racing pedigree, automotive, motorsport, and watch-collector clientele.',
        'Emerald Dark':  'Hotel-lobby green, the colour Rome, Milan, and Paris hospitality keep coming back to.'
      };
      var COLOR_FAMILY_BLURBS = {
        'Crimson':   'Cardinal red, ceremonial weight, graduation gravitas, never quiet.',
        'Oxblood':   'Old-money claret, quiet executive credibility on every hide.',
        'Mahogany':  'Boardroom mahogany, the panelled-library brown of law firms and private offices.',
        'Chestnut':  'Equestrian chestnut, saddle-shop warmth chosen by heritage and outdoor brands.',
        'Cognac':    'Dealership cognac, the colour you remember handing over with the keys.',
        'Amber':     'Warm amber, the boutique-hotel concierge desk in one tone.',
        'Brass':     'Brass-touched yellow-brown, reads like vintage hardware on leather.',
        'Olive':     'Olive, understated heritage; reads quietly intelligent in any room.',
        'Forest':    'Library-green warmth, the country-club and rare-book trade colour.',
        'Marine':    'Marine teal, a yachting-and-spa choice for hospitality programs.',
        'Navy':      'Navy, diplomatic, financial, the safest non-black for boardrooms.',
        'Indigo':    'Indigo, denim-house and selvedge heritage, a quiet creative-industry blue.',
        'Aubergine': 'Aubergine, couture-spec purple, never mass-market.',
        'Plum':      'Plum, editorial purple chosen by fashion-house gifting programs.',
        'Burgundy':  'Burgundy, wine-country heritage in a single hide.',
        'Onyx':      'Onyx, architectural black for crisp deboss and minimal branding.',
        'Espresso':  'Espresso, atelier-classic dark brown, photographs warmly.',
        'Slate Grey':'Slate grey, brutalist, brushed-steel-adjacent, modern in any decade.',
        'Stone':     'Stone, neutral and gallery-friendly, lets the foil do the talking.',
        'Sand':      'Sand, warm light neutral; pairs beautifully with gold leaf.',
        'Ivory':     'Ivory, wedding-and-yacht white-cream, never sterile.'
      };
      function blurbForColor(name, hex){
        if (COLOR_BLURBS[name]) return gcT(COLOR_BLURBS[name]);
        // Fallback: try matching the family stem from the generated nameForHex()
        var family = name.replace(/^(Black |Midnight |Deep |Dark |Soft |Light |Pale |Cream )/, '');
        if (COLOR_FAMILY_BLURBS[family]) return gcT(COLOR_FAMILY_BLURBS[family]);
        // Final fallback, still incentivizing, never empty
        return gcT('A custom-matched hide, dyed to spec at our atelier, paired with the leather of your choice.');
      }
      /* INP-friendly blurb swap: cancel any in-flight timeout, fade out via class toggle, swap text on next animation frame, fade back in. Pure GPU compositor work, never blocks the main thread. */
      var _blurbSwapTimer = null;
      function swapBlurb(el, next){
        if (!el) return;
        if (el.textContent === next) return;
        if (_blurbSwapTimer){ clearTimeout(_blurbSwapTimer); }
        el.classList.add('is-swapping');
        _blurbSwapTimer = setTimeout(function(){
          requestAnimationFrame(function(){
            el.textContent = next;
            requestAnimationFrame(function(){ el.classList.remove('is-swapping'); });
          });
        }, 200);
      }
      /* Smart blurb-space reservation: measure the longest blurb in the dictionary AT THE CURRENT VIEWPORT WIDTH and set the blurb element's min-height to that value. Works for translations + future copy. Re-runs on resize via debounced ResizeObserver / matchMedia. */
      function reserveBlurbSpace(){
        var bl = document.getElementById('m23-color-blurb');
        if (!bl) return;
        var w = bl.clientWidth;
        if (!w) return;
        var probe = document.createElement('p');
        probe.className = 'm23-color-blurb';
        probe.style.cssText = 'position:absolute;top:-9999px;left:-9999px;visibility:hidden;width:' + w + 'px;min-height:0;opacity:0;transform:none;transition:none';
        document.body.appendChild(probe);
        var max = 0;
        var all = Object.values(COLOR_BLURBS).concat(Object.values(COLOR_FAMILY_BLURBS));
        for (var i = 0; i < all.length; i++){
          probe.textContent = all[i];
          if (probe.scrollHeight > max) max = probe.scrollHeight;
        }
        document.body.removeChild(probe);
        if (max > 0) bl.style.minHeight = max + 'px';
      }
      // Run after first paint, then on resize
      if ('requestAnimationFrame' in window){
        (window.GCB2B_FONTS||Promise.resolve()).then(function(){return document.fonts&&document.fonts.load?Promise.all([document.fonts.load('400 12px Montserrat'),document.fonts.load('300 14px Montserrat'),document.fonts.load('500 14px Montserrat')]).catch(function(){}):null;}).then(function(){requestAnimationFrame(function(){ requestAnimationFrame(reserveBlurbSpace); });});
      } else {
        setTimeout(reserveBlurbSpace, 0);
      }
      (function(){
        var t = null;
        window.addEventListener('resize', function(){
          clearTimeout(t);
          t = setTimeout(reserveBlurbSpace, 150);
        }, { passive: true });
      })();

      function setLeatherColor(hex, name){
        hex = (hex || '').toUpperCase();
        /* If no name was passed, or the name is the same as the hex (custom picker case), generate a friendly name. */
        if (!name || name === hex || /^#?[0-9a-f]{6}$/i.test(name)){
          name = nameForHex(hex);
        }
        var sw = document.getElementById('m23-color-swatch');
        var nm = document.getElementById('m23-color-name');
        var dv = document.getElementById('m23-color-divider');
        var hx = document.getElementById('m23-color-hex');
        var bl = document.getElementById('m23-color-blurb');
        var pi = document.getElementById('m23-color-input');
        if(sw) sw.style.background = hex;
        if(nm){ nm.textContent = gcColorName(name); nm.hidden = false; }
        if(dv){ dv.hidden = false; }
        if(hx) hx.textContent = hex;
        if(bl) swapBlurb(bl, blurbForColor(name, hex));
        if(pi) pi.value = hex.length === 7 ? hex.toLowerCase() : pi.value;
      }
      /* expose colour-naming helpers so the quote form's brand-colour slider can show the same NAME + EXPLANATION as the catalogue readout */
      try{ window.nameForHex = nameForHex; window.blurbForColor = blurbForColor; window.uniqueColorNames = uniqueColorNames; }catch(_){}
      /* v13.5 add the m23 catalogue color + selected leather straight into the quote (flows through the form, which syncs to the cart) */
      window.gcAddMaterial=function(name){
        name=(name||'').trim(); if(!name) return false;
        var mi=document.getElementById('qf-material'); if(!mi) return false;
        var tile=null, low=name.toLowerCase();
        document.querySelectorAll('.qf-material').forEach(function(b){ if(tile)return; var dm=(b.dataset.material||b.getAttribute('title')||'').toLowerCase(); if(dm===low||dm.indexOf(low)!==-1||low.indexOf(dm)!==-1) tile=b; });
        var label = tile ? (tile.dataset.material||tile.getAttribute('title')) : name;
        if(tile){ tile.classList.add('active'); tile.setAttribute('aria-pressed','true'); }
        var arr=(mi.value||'').split(', ').filter(Boolean);
        if(arr.indexOf(label)===-1) arr.push(label);
        mi.value=arr.join(', ');
        if(typeof buildProjectSummary==='function') buildProjectSummary();
        if(window.gcSetMaterials) window.gcSetMaterials(arr);
        return true;
      };
      window.m23AddColor=function(){
        var hx=(document.getElementById('m23-color-hex')||{}).textContent||'';
        var ok = window.gcAddColor ? window.gcAddColor(hx) : false;
        var btn=document.getElementById('m23-readout-add');
        if(btn){
          /* Clear any in-flight reset timer FIRST: a leftover timer from a previous add must never stomp the confirmation of a new one. This is what made rapid "pick colour → add → pick another → add" feel broken. */
          if(btn._gcT){ clearTimeout(btn._gcT); }
          btn.classList.add('added');
          btn.textContent = ok ? gcT('✓ Color added') : gcT('Color limit reached');
          btn._gcT=setTimeout(function(){ btn.classList.remove('added'); btn.textContent=gcT('+ Add color to quote'); btn._gcT=null; }, 1000);
        }
      };
      window.m23AddLeather=function(){
        var leathers=(window.gcM23Leathers&&window.gcM23Leathers.length)?window.gcM23Leathers:(window.gcM23Leather?[window.gcM23Leather]:[]);
        var ok=false; leathers.forEach(function(nm){ if(window.gcAddMaterial && window.gcAddMaterial(nm)) ok=true; });
        var btn=document.getElementById('m23-leather-add');
        if(btn){
          if(btn._gcT){ clearTimeout(btn._gcT); }
          btn.classList.add('added');
          btn.textContent = ok ? gcT('✓ Leather added') : (leathers.length?gcT('Already added'):gcT('Tap a leather first'));
          btn._gcT=setTimeout(function(){ btn.classList.remove('added'); btn.textContent=gcT('+ Add leather to quote'); btn._gcT=null; }, 1000);
        }
      };
      document.addEventListener('click', function(e){
        var chip=e.target.closest('.m23-leather-strips .m23-leather-chip'); if(!chip) return;
        chip.classList.toggle('is-sel');
        chip.setAttribute('aria-pressed', chip.classList.contains('is-sel')?'true':'false');
        window.gcM23Leathers=[].map.call(document.querySelectorAll('.m23-leather-strips .m23-leather-chip.is-sel'),function(c){var l=c.querySelector('.m23-leather-chip-label');return l?l.textContent.trim():'';}).filter(Boolean);
        window.gcM23Leather=window.gcM23Leathers[window.gcM23Leathers.length-1]||'';
        var lr=document.getElementById('m23-leather-readout-names');
        if(lr){
          if(window.gcM23Leathers.length){
            lr.classList.remove('is-empty');
            lr.innerHTML = window.gcM23Leathers.map(function(n){
              var esc=String(n).replace(/[&<>"]/g,function(c){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c];});
              return '<span class="m23-leather-tag">'+esc+'</span>';
            }).join('');
          } else {
            lr.classList.add('is-empty');
            lr.textContent=gcT('Tap a leather above to begin');
          }
        }
      });
      /* Chip activation fires on POINTERDOWN (not click) so a focus-induced scrollIntoView can't yank the chip away between mousedown and mouseup. Keyboard users get an Enter/Space handler separately. */
      function activateColorChip(chip){
        if (!chip) return;
        document.querySelectorAll('.m23-color-chip').forEach(function(x){
          x.classList.remove('active');
          x.setAttribute('aria-pressed','false');
        });
        chip.classList.add('active');
        chip.setAttribute('aria-pressed','true');
        setLeatherColor(chip.dataset.color, chip.dataset.name);
      }
      document.addEventListener('pointerdown', function(e){
        if (e.button !== undefined && e.button !== 0) return;
        var chip = e.target.closest('.m23-color-chip');
        if (!chip) return;
        activateColorChip(chip);
      });
      document.addEventListener('keydown', function(e){
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var chip = document.activeElement;
        if (!chip || !chip.classList || !chip.classList.contains('m23-color-chip')) return;
        e.preventDefault();
        activateColorChip(chip);
      });

      /* Custom inline hex picker: opens between the color rows and the readout so it never occludes the readout the way the OS color dialog did. Live preview: typing in the hex input updates the readout and the bead in real time. The OS picker is still reachable via the palette button inside the popover for users who want full color-wheel control. */
      (function(){
        var btn = document.getElementById('m23-color-picker-btn');
        var pop = document.getElementById('m23-color-popover');
        var inp = document.getElementById('m23-color-popover-input');
        var bead = document.getElementById('m23-color-popover-bead');
        var osBtn = document.getElementById('m23-color-popover-os');
        var closeBtn = document.getElementById('m23-color-popover-close');
        var native = document.getElementById('m23-color-input');
        if (!btn || !pop || !inp || !bead) return;

        function open(){
          pop.hidden = false;
          /* Force reflow so the max-height transition runs cleanly from 0. */
          void pop.offsetHeight;
          pop.classList.add('is-open');
          btn.setAttribute('aria-expanded','true');
          /* Pre-fill with whichever color is currently selected in the readout. */
          var hx = (document.getElementById('m23-color-hex') || {}).textContent || '';
          var clean = hx.replace(/^#/,'').toUpperCase();
          if (/^[0-9A-F]{6}$/.test(clean)){
            inp.value = clean;
            bead.style.background = '#' + clean;
          }
          setTimeout(function(){ try { inp.focus({preventScroll:true}); inp.select(); } catch(e) { try { inp.focus(); inp.select(); } catch(_) {} } }, 80);
        }
        function close(){
          pop.classList.remove('is-open');
          btn.setAttribute('aria-expanded','false');
          /* Hide after transition completes so it leaves the a11y tree. */
          setTimeout(function(){ if (!pop.classList.contains('is-open')) pop.hidden = true; }, 360);
        }
        btn.addEventListener('click', function(e){
          e.preventDefault();
          if (btn.getAttribute('aria-expanded') === 'true') close(); else open();
        });
        closeBtn && closeBtn.addEventListener('click', close);
        osBtn && osBtn.addEventListener('click', function(){ if (native) native.click(); });

        inp.addEventListener('input', function(){
          /* Sanitize: hex chars only, max 6, uppercase visually. */
          var v = inp.value.replace(/[^0-9a-fA-F]/g,'').slice(0,6).toUpperCase();
          if (v !== inp.value) inp.value = v;
          if (v.length === 6){
            var h = '#' + v;
            bead.style.background = h;
            if (typeof setLeatherColor === 'function') setLeatherColor(h, h);
            if (native) native.value = h.toLowerCase();
          }
        });
        inp.addEventListener('keydown', function(e){
          if (e.key === 'Enter'){ e.preventDefault(); close(); btn.focus(); }
          if (e.key === 'Escape'){ e.preventDefault(); close(); btn.focus(); }
        });

        /* Outside-click closes. Use pointerdown so the close happens before any other click handler that might reopen. */
        document.addEventListener('pointerdown', function(e){
          if (!pop.classList.contains('is-open')) return;
          if (pop.contains(e.target) || btn.contains(e.target)) return;
          close();
        });

        /* OS-picker → also mirror back into the inline UI and the readout. */
        if (native){
          native.addEventListener('input', function(){
            var h = (native.value || '').toString();
            if (!h) return;
            bead.style.background = h;
            inp.value = h.replace(/^#/,'').toUpperCase();
            if (typeof setLeatherColor === 'function') setLeatherColor(h, h);
          });
        }
      })();

      function centerIndCard(el){
        var strip = document.getElementById('ind-strip');
        if(!strip || !el) return;
        var stripRect = strip.getBoundingClientRect();
        var cardRect = el.getBoundingClientRect();
        var cardCenter = (cardRect.left + cardRect.right) / 2;
        var stripCenter = (stripRect.left + stripRect.right) / 2;
        strip.scrollBy({left: cardCenter - stripCenter, behavior:'smooth'});
      }
  
    
      function m26TrustTab(which){
        document.querySelectorAll('.m26-trust-tab').forEach(b => {
          var on = b.dataset.trustTab === which;
          b.classList.toggle('active', on);
          b.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var photos = document.getElementById('m26-trust-photos');
        var videos = document.getElementById('m26-trust-videos');
        if(photos) photos.hidden = which !== 'photos';
        if(videos) videos.hidden = which !== 'videos';
      }
  
    function m03Scroll(dir){
        const el = document.getElementById('m03-grid');
        if(el) el.scrollBy({left: dir * Math.min(360, el.clientWidth*0.85), behavior:'smooth'});
      }
      

        try{
          var COLLAB_PREFILL={subject:"B2B Collaboration Inquiry",topic:"collaboration",message:"Hi GENTCREATE team, I'd like to discuss a capsule collaboration.\n\n• Brand / audience context: [your brand]\n• Estimated launch window: [month]\n• Quantity range: [MOQ]\n• Categories of interest: [phone cases / wallets / other]"};
          document.querySelectorAll('a[href*="ref=b2b-collaboration"]').forEach(function(a){
            a.addEventListener('click', function(){
              try{ localStorage.setItem('gc_contact_prefill', JSON.stringify(COLLAB_PREFILL)); }catch(_){}
            }, {passive:true});
          });
        }catch(_){}
      var m19CatIdx = 0;
      function m19Cat(dir){
        var slides = document.querySelectorAll('#m19-cat .m19-cat-slide');
        var dots = document.querySelectorAll('#m19-cat .m19-cat-dot');
        if(!slides.length) return;
        m19CatIdx = (m19CatIdx + dir + slides.length) % slides.length;
        m19CatGo(m19CatIdx);
      }
      function m19CatGo(i){
        var slides = document.querySelectorAll('#m19-cat .m19-cat-slide');
        var dots = document.querySelectorAll('#m19-cat .m19-cat-dot');
        var counter = document.getElementById('m19-cat-counter');
        m19CatIdx = i;
        slides.forEach(function(s,j){ s.classList.toggle('active', j===i); });
        dots.forEach(function(d,j){ d.classList.toggle('active', j===i); });
        if(counter) counter.textContent = (i+1) + ' / ' + slides.length;
      }
      (function initM19Cat(){
        var stage = document.querySelector('#m19-cat .m19-cat-stage');
        if(!stage) return;
        document.querySelectorAll('#m19-cat .m19-cat-dot').forEach(function(d){
          d.addEventListener('click', function(){ m19CatGo(parseInt(d.dataset.i,10)); });
        });
        var sx=0, sy=0;
        stage.addEventListener('touchstart', function(e){ sx=e.touches[0].clientX; sy=e.touches[0].clientY; }, {passive:true});
        stage.addEventListener('touchend', function(e){
          var dx = e.changedTouches[0].clientX - sx;
          var dy = e.changedTouches[0].clientY - sy;
          if(Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) m19Cat(dx > 0 ? -1 : 1);
        }, {passive:true});
        document.addEventListener('keydown', function(e){
          if(!stage.getBoundingClientRect().top || stage.getBoundingClientRect().top > window.innerHeight) return;
          if(e.key === 'ArrowLeft') m19Cat(-1);
          else if(e.key === 'ArrowRight') m19Cat(1);
        });
      })();
  
    function m24Scroll(which, dir){
        const el = document.getElementById('m24-' + which);
        if(el) el.scrollBy({left: dir * Math.min(360, el.clientWidth*0.85), behavior:'smooth'});
      }
      function scrollLeatherStrip(dir){
        const s = document.getElementById('m23-leather-scroll');
        if(s) s.scrollBy({left: dir*240, behavior:'smooth'});
      }
  
    // PRODUCT DRAWER
    function toggleDrawer(catId,prodName){
    const cat=CATALOG.find(c=>c.id===catId);
    const prod=cat.products.find(p=>p.n===prodName);
    const drawer=document.getElementById('drawer-'+catId);
    if(drawer.dataset.open===prodName){drawer.classList.remove('open');drawer.dataset.open='';return;}
    document.querySelectorAll('.m23-drawer').forEach(d=>{d.classList.remove('open');d.dataset.open='';});
    const subs=(prod.subs||[]).map(s=>{
      const safeS=s.replace(/'/g,"\\'");const safeP=prodName.replace(/'/g,"\\'");
      return '<button class="m23-sub" type="button" onclick="selectSub(\''+safeP+'\',\''+safeS+'\')" aria-label="'+gcT(s)+'">'+subIcon(prodName,s)+'<span class="m23-sub-name">'+gcT(s)+'</span></button>';
    }).join('');
    const popularLabel=prod.pop?' &middot; <span class="pop-marker">'+gcT('Most Popular')+'</span>':'';
    /* v7: dedupe drawer CTAs via shared quoteCta() helper. When live, show "View page" + "Quote"; when planned, only show ONE Quote CTA. */
    const safePI=prodName.replace(/'/g,"\\'");
    const ctaQuote=quoteCta(safePI,gcT('Quote this product'),true);
    const ctaPage='<a href="#quote-form" class="btn sm filled" data-gcb2b-ask="'+gcAsk(prodName)+'" data-gcb2b-kind="product">'+gcT('Add to quote \u2192')+'</a>';
    drawer.innerHTML='<div class="m23-drawer-head"><div class="m23-drawer-title">'+gcT(prodName)+popularLabel+'</div><button class="m23-drawer-close" type="button" onclick="this.closest(\'.m23-drawer\').classList.remove(\'open\');this.closest(\'.m23-drawer\').dataset.open=\'\';">&times;</button></div><div class="m23-drawer-label">'+((prod.subs&&prod.subs.length)?gcT('Sub-types of {p} we produce').replace('{p}',window.gcLowerProduct(gcT(prodName))):gcT('Available customization options for {p}').replace('{p}',window.gcLowerProduct(gcT(prodName))))+'</div><div class="m23-subs">'+(subs||'<em style="color:var(--gc-muted);font-size:12px">'+gcT('Standard configuration only \u2014 add specifics in the quote form')+'</em>')+'</div><div class="m23-drawer-actions">'+ctaPage+'</div>';
    drawer.classList.add('open');drawer.dataset.open=prodName;
    setTimeout(()=>drawer.scrollIntoView({behavior:'smooth',block:'nearest'}),120);
  }
  function selectSub(prod,sub){gcAddToQuote(prod+' \u2014 '+sub);}
  /* v10 #3: leather-aware search */
    /* v13.1+ Filter-module counters wired to live DOM counts so future additions are auto-reflected (no hard-coded "19 types" / "14 brand-matched"). Re-runs on load in case chips are mutated later by JS. */
    (function syncFilterCounts(){
      function tick(){
        var leatherCount = document.querySelectorAll('.m23-leather-strips .m23-leather-chip').length;
        var colorCount = document.querySelectorAll('.m23-color-strip .m23-color-chip').length;
        document.querySelectorAll('[data-count-leather]').forEach(function(el){ if (leatherCount) el.textContent = leatherCount; });
        document.querySelectorAll('[data-count-color]').forEach(function(el){ if (colorCount) el.textContent = colorCount; });
      }
      tick();
      if (document.readyState !== 'complete') window.addEventListener('load', tick, { once: true });
    })();

    /* v13.1+ Keyboard accessibility for horizontal chip tracks, Tab/ArrowLeft/ArrowRight/Home/End navigation.
       CRITICAL: focusin auto-scroll fires ONLY when the user is in keyboard mode. If we scroll on mouse focus, the chip moves under the cursor between mousedown and mouseup and the click never registers. We track keyboard vs. mouse mode globally. */
    (function trackArrowNav(){
      var keyboardMode = false;
      window.addEventListener('keydown', function(e){
        if (['Tab','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Home','End',' ','Enter'].indexOf(e.key) !== -1){
          keyboardMode = true;
        }
      }, true);
      window.addEventListener('mousedown', function(){ keyboardMode = false; }, true);
      window.addEventListener('touchstart', function(){ keyboardMode = false; }, { capture: true, passive: true });

      var selectors = ['.m23-color-track','.m23-leather-scroll','.m24b-color-track','.qf-material-grid'];
      selectors.forEach(function(sel){
        document.querySelectorAll(sel).forEach(function(track){
          function focusables(){
            return Array.from(track.querySelectorAll('button:not([disabled]):not([hidden]), input:not([disabled]):not([type=hidden]), [tabindex]:not([tabindex="-1"])'))
                       .filter(function(el){
                         var s = window.getComputedStyle(el);
                         return s.display !== 'none' && s.visibility !== 'hidden';
                       });
          }
          // Auto-scroll into view ONLY for keyboard focus, never on mouse click (would yank the chip away from the cursor mid-click).
          track.addEventListener('focusin', function(e){
            if (!keyboardMode) return;
            var t = e.target;
            if (t && t.scrollIntoView && track.contains(t)){
              t.scrollIntoView({block:'nearest', inline:'center', behavior:'smooth'});
            }
          });
          track.addEventListener('keydown', function(e){
            if (['ArrowLeft','ArrowRight','Home','End'].indexOf(e.key) === -1) return;
            if (!track.contains(document.activeElement)) return;
            var f = focusables();
            if (!f.length) return;
            var idx = f.indexOf(document.activeElement);
            if (idx === -1) idx = 0;
            e.preventDefault();
            e.stopPropagation();
            var next = idx;
            if (e.key === 'ArrowRight') next = Math.min(f.length - 1, idx + 1);
            else if (e.key === 'ArrowLeft') next = Math.max(0, idx - 1);
            else if (e.key === 'Home') next = 0;
            else if (e.key === 'End') next = f.length - 1;
            f[next].focus();
          }, true);
        });
      });
    })();

    const LEATHER_KEYWORDS=('tuscan full-grain saffiano nappa pebbled vegetable-tanned bridle '+
      'crocodile alligator caiman python ostrich himalayan siamese nile karung diamondback '+
      'reticulated burmese lizard stingray shark eel kangaroo elephant cactus mushroom '+
      'plant-based vegan exotic italian leather suede nubuck smooth grain pull-up patent metallic '+
      'foiled embossed').split(' ');
    function filterBubbles(q){
      const term=q.toLowerCase().trim();
      const isLeather=!!term && LEATHER_KEYWORDS.some(k => k.includes(term) || term.includes(k));
      document.querySelectorAll('.m23-bubble').forEach(b=>{
        const name=b.querySelector('.m23-bubble-name').textContent.toLowerCase();
        const subs=(CATALOG.find(c=>c.id===b.dataset.cat)?.products.find(p=>p.n===b.dataset.prod)?.subs||[]).join(' ').toLowerCase();
        b.style.display=(!term||name.includes(term)||subs.includes(term)||isLeather)?'':'none';
    });
    document.querySelectorAll('.m23-cat').forEach(cat=>{
      const visible=[...cat.querySelectorAll('.m23-bubble')].some(b=>b.style.display!=='none');
      cat.style.display=visible?'':'none';
    });
    /* Collapse the Material + Color filter stack while the user is searching so the bubble results are visible without scroll. Restored when the search clears. */
    const stack = document.getElementById('m23-filter-stack');
    if (stack){ stack.classList.toggle('is-collapsed', !!term); }
    setTimeout(updateBubbleArrows,50);
  }
  function customRequest(){gcAddToQuote('Custom Request: '+(document.getElementById('bubble-search').value||'[describe in message]'));}
    /* v8: login modal */
    function openLogin(){var m=document.getElementById('loginModal');if(!m)return;m.classList.add('open');m.setAttribute('aria-hidden','false');document.documentElement.style.overflow='hidden';document.body.style.overflow='hidden';setTimeout(function(){var i=m.querySelector('input');if(i)i.focus();},50);}
    function closeLogin(){var m=document.getElementById('loginModal');if(!m)return;m.classList.remove('open');m.setAttribute('aria-hidden','true');document.documentElement.style.overflow='';document.body.style.overflow='';}
    function switchLoginTab(t){document.querySelectorAll('.gc-modal-tab').forEach(function(b){var on=b.getAttribute('data-tab')===t;b.classList.toggle('active',on);b.setAttribute('aria-selected',on?'true':'false');});document.getElementById('signinForm').style.display=t==='signin'?'flex':'none';document.getElementById('registerForm').style.display=t==='register'?'flex':'none';}
    /* Quick vs Full register switcher, quick hides the extras, full reveals everything. */
    function switchRegisterMode(mode){
      var form = document.getElementById('registerForm'); if(!form) return;
      form.querySelectorAll('.gc-register-mode-btn').forEach(function(b){
        var on = b.dataset.mode === mode;
        b.classList.toggle('active', on);
        b.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      var extra = form.querySelector('[data-register-extra]');
      var cta = form.querySelector('[data-register-cta]');
      var hint = form.querySelector('[data-register-hint]');
      if (mode === 'full'){
        if (extra) extra.hidden = false;
        if (cta) cta.textContent = gcT('Create Corporate Account');
        if (hint) hint.textContent = gcT('Approved within 1 business day. We may verify your company by phone or email.');
      } else {
        if (extra) extra.hidden = true;
        if (cta) cta.textContent = gcT('Create Account');
        if (hint) hint.textContent = gcT('Two fields to start. You can complete your corporate profile after signing in. Approved within 1 business day.');
      }
    }
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeLogin();});
    /* v8 CRIT: m24 slideshow a11y, focusable cards + arrow-key nav */
    (function(){
      var sets = [{wrap:'.m24-tiers', card:'.m24-tier'},{wrap:'.m24-gallery', card:'.m24-collab-card'}];
      sets.forEach(function(s){
        document.querySelectorAll(s.card).forEach(function(c){c.setAttribute('tabindex','0');c.setAttribute('role','group');});
        var wrap = document.querySelector(s.wrap);
        if(!wrap) return;
        wrap.addEventListener('keydown', function(e){
          if(e.key!=='ArrowLeft' && e.key!=='ArrowRight') return;
          var cards = Array.prototype.slice.call(wrap.querySelectorAll(s.card));
          var idx = cards.indexOf(document.activeElement);
          if(idx<0) return;
          e.preventDefault();
          var next = e.key==='ArrowRight' ? Math.min(idx+1,cards.length-1) : Math.max(idx-1,0);
          cards[next].focus({preventScroll:false});
          cards[next].scrollIntoView({behavior:'smooth',block:'nearest',inline:'center'});
        });
      });
    })();

  function toggleChat(){const p=document.getElementById('chatbot');const open=p.classList.toggle('open');p.setAttribute('aria-hidden',String(!open));}
  function appendMsg(text,who){const body=document.getElementById('chatbot-body');const div=document.createElement('div');div.className='chat-msg '+who;div.textContent=text;body.appendChild(div);body.scrollTop=body.scrollHeight;}
  function findAnswer(q){const term=q.toLowerCase();let hit=CHAT_KB.find(k=>k.q.toLowerCase()===term);if(hit)return hit.a;const words=term.split(/\s+/).filter(w=>w.length>3);let best=null,bestScore=0;CHAT_KB.forEach(k=>{const text=(k.q+' '+k.a).toLowerCase();const score=words.filter(w=>text.includes(w)).length;if(score>bestScore){bestScore=score;best=k;}});if(best&&bestScore>=1)return best.a;return "Great question. I'll route you to a human AM \u2014 they'll respond within one business day. In the meantime, you can: (1) submit the quote form above with your question, or (2) email wholesale@gentcreate.com directly.";}
  function askChat(q){appendMsg(q,'user');setTimeout(()=>appendMsg(findAnswer(q),'bot'),400);}
  function sendChat(){const input=document.getElementById('chat-input');if(!input.value.trim())return;askChat(input.value.trim());input.value='';}

  /* v7: shared CTA helper, eliminates inline CTA duplication across drawers, custom requests, etc */
  function quoteCta(productInterest,label,filled){
    const cls=filled?'btn sm filled':'btn sm';
    const safe=String(productInterest||'').replace(/'/g,"\\'");
    return '<a href="#quote-form" class="'+cls+'" onclick="setQuoteProduct(\''+safe+'\');return false;">'+(label||gcT('Quote this product'))+'</a>';
  }

  /* v6: pricing accordion, open all on desktop, only featured on mobile */
  (function(){
    const setOpen=()=>{
      const isMobile=window.innerWidth<=980;
      document.querySelectorAll('.m07-card').forEach(c=>{
        if(!isMobile){c.setAttribute('open','');}
        else{if(c.classList.contains('featured'))c.setAttribute('open','');else c.removeAttribute('open');}
      });
    };
    setOpen();
    let t;window.addEventListener('resize',()=>{clearTimeout(t);t=setTimeout(setOpen,150);});
  })();

  /* ==== v8: sticky CTA is a single static button, no JS content swap needed ==== */

    
  /* ==== v10.3: m12 By-Product auto-builder, keeps list synced with m23 ==== */
    (function(){
      const target = document.querySelector('#m12-by-product ul'); if(!target) return;
      const seen = new Set(); const items = [];
      document.querySelectorAll('.m23-bubble').forEach(function(b){
        const n = (b.dataset.prod||'').trim(); if(!n||seen.has(n)) return; seen.add(n);
        const slug = n.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
        var gcb2bHref = window.gcb2bPageFor(n);
        items.push(gcb2bHref ? '<li><a href="'+gcb2bHref+'">'+gcT(n)+'</a></li>' : '<li><a href="#quote-form" data-gcb2b-ask="'+gcAsk(n)+'" data-gcb2b-kind="product">'+gcT(n)+'</a></li>');
      });
      const cap = 12;
      const head = items.slice(0, cap).join('');
      const more = Math.max(0, items.length - cap);
      target.innerHTML = head + (more ? '<li><a href="#products" style="font-weight:600">'+gcT('+ {n} more →').replace('{n}',more)+'</a></li>' : '');
    })();

    /* ==== v10.3: qfMaterialScroll helper for material slider arrows ==== */
    window.qfMaterialScroll = function(dir){
      const el = document.getElementById('qf-material-grid'); if(!el) return;
      el.scrollBy({left: dir * Math.max(220, el.clientWidth*0.6), behavior:'smooth'});
    };
    /* ==== v10.2: MARQUEE rAF, reliable horizontal scroll on file:// + every breakpoint ==== */
    (function(){
      const tracks=document.querySelectorAll('.m22-marquee-track');
      tracks.forEach(function(track){
        const aside=track.closest('.m22-marquee');
        let x=0, paused=false, last=performance.now();
        let speed= (window.innerWidth<=720) ? 60 : 40; /* px/sec */
        function step(now){
          const dt=(now-last)/1000; last=now;
          if(!paused){
            x -= speed*dt;
            const halfW=track.scrollWidth/2;
            if(halfW>0 && -x >= halfW) x += halfW;
            track.style.transform='translate3d('+x.toFixed(2)+'px,0,0)';
          }
          requestAnimationFrame(step);
        }
        if(aside){
          aside.addEventListener('mouseenter',function(){paused=true;});
          aside.addEventListener('mouseleave',function(){paused=false;});
        }
        window.addEventListener('resize',function(){speed=(window.innerWidth<=720)?60:40;});
        requestAnimationFrame(step);
      });
    })();

    /* ==== v10.2: BUBBLE PHOTO LOADER, sync <img onerror=remove> overlays SVG; works on file:// ==== */
    (function(){
      function slugify(s){return s.toLowerCase().replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');}
      const BUBBLE_ALIASES={'card-holders':'cardholder','wallets':'wallet','padfolios':'padfolio','phone-cases':'phonecase','journals':'journal','keychains':'keychain','passport-holders':'passport','restaurant-menu-covers':'menu','whiskey-glass-holders':'whisky-glass-holders','airpods-cases':'airpods','backpacks':'backpack'};
      document.querySelectorAll('.m23-bubble').forEach(function(b){
        const name=b.dataset.prod;if(!name)return;
        const icon=b.querySelector('.m23-bubble-icon');
        if(!icon||icon.querySelector('.m23-bubble-photo'))return; /* already has inline photo */
        const slug=slugify(name);
        const stem=BUBBLE_ALIASES[slug]||slug;
        const url=window.GCB2B_ASSET_BASE+'gcb2b-bubble-'+stem+'.webp';
        const img=document.createElement('img');
        img.className='m23-bubble-photo m23-bubble-photo-img';
        img.src=url; img.alt=''; img.loading='lazy';
        img.onerror=function(){this.remove();};
        icon.appendChild(img);
      });
    })();

  /* ==== v7: QUOTE FORM PERSISTENCE, saves draft to localStorage as user types, restores on next visit ==== */
  (function(){
    const form=document.getElementById('m14-form');if(!form)return;
    const KEY='gc-quote-draft';
    const fields=[...form.querySelectorAll('input:not([type=hidden]):not([type=submit]),select,textarea')].filter(f=>f.id);
    let restored=false;
    try{
      const saved=JSON.parse(localStorage.getItem(KEY)||'{}');
      let any=false;
      fields.forEach(f=>{if(saved[f.id]!=null&&saved[f.id]!==''){f.value=saved[f.id];any=true;}});
      if(any){restored=true;document.getElementById('m14-form-saved').hidden=false;}
    }catch(e){}
    let saveTimer;
    function save(){
      clearTimeout(saveTimer);
      saveTimer=setTimeout(()=>{
        const data={};let any=false;
        fields.forEach(f=>{if(f.value){data[f.id]=f.value;any=true;}});
        try{
          if(any){localStorage.setItem(KEY,JSON.stringify(data));}
          else{localStorage.removeItem(KEY);document.getElementById('m14-form-saved').hidden=true;}
        }catch(e){}
      },350);
    }
    fields.forEach(f=>{f.addEventListener('input',save);f.addEventListener('change',save);});
  })();
  

/* ---- from: body ---- */

  (function(){
    var strip = document.querySelector('.ind-strip');
    /* v10 #11: 3D viewer control helpers */
    window.m25Zoom = function(dir){
      var v = document.querySelector('.m25-viewer'); if(!v) return;
      var orbit = v.getCameraOrbit ? v.getCameraOrbit() : null;
      if(!orbit) return;
      var r = orbit.radius * (dir>0 ? 0.85 : 1.18);
      v.cameraOrbit = orbit.theta+'rad '+orbit.phi+'rad '+r+'m';
    };
    window.m25Reset = function(){
      var v = document.querySelector('.m25-viewer'); if(!v) return;
      v.cameraOrbit = '0deg 75deg auto';
      v.cameraTarget = 'auto auto auto';
      v.fieldOfView = 'auto';
    };
    window.m25ToggleSpin = function(btn){
      var v = document.querySelector('.m25-viewer'); if(!v) return;
      var on = v.hasAttribute('auto-rotate');
      if(on){ v.removeAttribute('auto-rotate'); btn.style.background='rgba(218,185,62,.85)'; btn.style.color='var(--gc-black)'; }
      else  { v.setAttribute('auto-rotate',''); btn.style.background=''; btn.style.color=''; }
    };
  
    if (!strip) return;
    var rafId = null, vx = 0;
    function tick(){
      if (Math.abs(vx) > 0.4) { strip.scrollLeft += vx; rafId = requestAnimationFrame(tick); }
      else { rafId = null; vx = 0; }
    }
    function setVxFromEvent(e){
      var r = strip.getBoundingClientRect();
      var x = e.clientX - r.left;
      var center = r.width / 2;
      var dead = r.width * 0.18;
      var delta = x - center;
      if (Math.abs(delta) < dead) { vx = 0; return; }
      var sign = delta > 0 ? 1 : -1;
      var dist = (Math.abs(delta) - dead) / (center - dead);
      vx = sign * Math.pow(dist, 1.6) * 14;
      if (rafId === null) rafId = requestAnimationFrame(tick);
    }
    strip.addEventListener('mousemove', setVxFromEvent);
    strip.addEventListener('mouseleave', function(){ vx = 0; });
    strip.addEventListener('touchstart', function(){ vx = 0; }, {passive:true});
  })();

  (function(){
    document.querySelectorAll('.m23-carousel').forEach(function(car){
      var bubbles = car.querySelector('.m23-bubbles');
      if (!bubbles) return;
      var t = null;
      bubbles.addEventListener('scroll', function(){
        car.classList.add('scrolling');
        clearTimeout(t);
        t = setTimeout(function(){ car.classList.remove('scrolling'); }, 900);
      }, {passive:true});
      car.addEventListener('touchstart', function(){
        car.classList.add('scrolling');
        clearTimeout(t);
        t = setTimeout(function(){ car.classList.remove('scrolling'); }, 1400);
      }, {passive:true});
    });
  })();

  (function(){
    var origToggle = window.toggleDrawer;
    if (typeof origToggle !== 'function') return;
    window.toggleDrawer = function(catId, prodName){
      var ret = origToggle.apply(this, arguments);
      document.querySelectorAll('.m23-bubble.is-open').forEach(function(b){ b.classList.remove('is-open'); });
      var sel = '.m23-bubble[data-cat="' + (catId||'').replace(/"/g,'\\"') + '"][data-prod="' + (prodName||'').replace(/"/g,'\\"') + '"]';
      var drawerOpen = document.querySelector('.m23-drawer.open');
      if (drawerOpen) document.querySelectorAll(sel).forEach(function(b){ b.classList.add('is-open'); });
      return ret;
    };
    document.addEventListener('click', function(e){
      var t = e.target;
      if (t && t.classList && t.classList.contains('m23-drawer-close')) {
        setTimeout(function(){
          document.querySelectorAll('.m23-bubble.is-open').forEach(function(b){ b.classList.remove('is-open'); });
        }, 0);
      }
    });
  })();

  (function(){
    var track = document.getElementById('qf-color-track');
    var thumb = document.getElementById('qf-color-thumb');
    var swatch = document.getElementById('qf-color-swatch');
    var hexIn = document.getElementById('qf-color');
    if (!track || !thumb || !swatch || !hexIn) return;
    var rName=document.getElementById('qf-color-readout-name');
    var rBlurb=document.getElementById('qf-color-readout-blurb');
    function updateReadout(hex){
      var nm=(typeof window.nameForHex==='function')?window.nameForHex(hex):(hex||'').toUpperCase();
      if(rName) rName.textContent=nm;
      if(rBlurb && typeof window.blurbForColor==='function') rBlurb.textContent=window.blurbForColor(nm,hex);
      /* keep the hex-grid picker in sync: bead, input value, and highlighted cell */
      var gb=document.getElementById('qf-hexgrid-bead'); if(gb) gb.style.background=hex;
      var gi=document.getElementById('qf-hexgrid-input'); if(gi && document.activeElement!==gi) gi.value=(hex||'').replace('#','').toUpperCase();
      var g=document.getElementById('qf-hexgrid');
      if(g){ var hl=(hex||'').toLowerCase(); g.querySelectorAll('.qf-hexgrid-cell').forEach(function(c){ c.classList.toggle('sel',(c.dataset.hex||'').toLowerCase()===hl); }); }
    }
    function hslToHex(h,s,l){
      s/=100; l/=100;
      var k=function(n){return (n+h/30)%12;};
      var a=s*Math.min(l,1-l);
      var f=function(n){var c=l-a*Math.max(-1,Math.min(k(n)-3,Math.min(9-k(n),1)));return Math.round(255*c).toString(16).padStart(2,'0');};
      return '#'+f(0)+f(8)+f(4);
    }
    function hexToHue(hex){
      var m=/^#?([0-9a-f]{6})$/i.exec(hex||''); if(!m) return null;
      var n=parseInt(m[1],16);
      var r=((n>>16)&255)/255, g=((n>>8)&255)/255, b=(n&255)/255;
      var max=Math.max(r,g,b), min=Math.min(r,g,b);
      if(max===min) return 0;
      var d=max-min, h=0;
      switch(max){case r:h=(g-b)/d+(g<b?6:0);break;case g:h=(b-r)/d+2;break;case b:h=(r-g)/d+4;break;}
      return h*60;
    }
    var hue=0;
    function paint(){
      thumb.style.left=(hue/360*100)+'%';
      var hex=hslToHex(hue,70,45);
      thumb.style.setProperty('--qf-thumb-color', hex);
      swatch.style.background=hex;
      hexIn.value=hex.toUpperCase();
      updateReadout(hex);
      track.setAttribute('aria-valuenow',String(Math.round(hue)));
      try{localStorage.setItem('gc-quote-color',hex);}catch(e){}
    }
    function setHueFromX(cx){
      var r=track.getBoundingClientRect();
      hue=Math.max(0,Math.min(1,(cx-r.left)/r.width))*360;
      paint();
    }
    function setHex(hex){
      var h=hexToHue(hex); if(h==null) return;
      hue=h;
      thumb.style.left=(hue/360*100)+'%';
      thumb.style.setProperty('--qf-thumb-color', hex);
      swatch.style.background=hex;
      hexIn.value=hex.toUpperCase();
      updateReadout(hex);
      track.setAttribute('aria-valuenow',String(Math.round(hue)));
      try{localStorage.setItem('gc-quote-color',hex);}catch(e){}
    }
    /* Resolve a typed value to a hex: accepts #abc / #aabbcc / aabbcc hex, OR a colour NAME — first the
       brand palette (so "navy" = our navy, "oxblood", "cognac", "tobacco", etc.), then ANY CSS colour
       name (red, teal, maroon, salmon, …) via the browser's own parser. Returns null if unrecognised. */
    var _probe=null;
    function resolveColorInput(raw){
      var s=(raw||'').trim().toLowerCase().replace(/\s+/g,' ');
      if(!s) return null;
      var h6=/^#?([0-9a-f]{6})$/.exec(s); if(h6) return '#'+h6[1];
      var h3=/^#?([0-9a-f]{3})$/.exec(s); if(h3) return '#'+h3[1].replace(/(.)/g,'$1$1');
      var BRAND={
        'onyx':'#0d0d0d','jet':'#0d0d0d','espresso':'#2e211a','charcoal':'#2b2b2b','slate':'#565b60','slate grey':'#565b60','slate gray':'#565b60','stone':'#9c968c','pewter':'#8c9196','gunmetal':'#2a2f33','sand':'#d8c9a6','ivory':'#efe9dd','cream':'#efe9dd',
        'oxblood':'#4a1216','burgundy':'#5c1f2a','wine':'#5c1f2a','claret':'#531825','maroon':'#5a1a1a','crimson':'#b3122a','scarlet':'#c01b22','mahogany':'#5b2a1c','chestnut':'#6b3f24','cognac':'#8a5a2b','caramel':'#9c6324','camel':'#b07a3c','tan':'#a9743e','tobacco':'#3a2417','rust':'#8a3b1e','amber':'#b07d1a','brass':'#9a7b1a','mustard':'#9a7b1a','gold':'#c9a227',
        'olive':'#5e5a22','forest':'#14401f','forest green':'#14401f','hunter green':'#22392b','bottle green':'#0f3d2e','racing green':'#11362a','emerald':'#0f5132','sage':'#6e7a55',
        'marine':'#1f6f6b','teal':'#1f6f6b','navy':'#0c1830','midnight navy':'#0c1830','indigo':'#28206a','aubergine':'#3a1f3f','eggplant':'#3a1f3f','plum':'#5a2747'
      };
      if(BRAND[s]) return BRAND[s];
      try{
        if(!_probe){ _probe=document.createElement('span'); _probe.style.cssText='position:absolute;left:-9999px;top:-9999px;width:0;height:0;pointer-events:none'; }
        _probe.style.color=''; _probe.style.color=s;
        if(_probe.style.color){
          document.body.appendChild(_probe);
          var rgb=getComputedStyle(_probe).color;
          document.body.removeChild(_probe);
          var m=/rgba?\((\d+),\s*(\d+),\s*(\d+)/.exec(rgb||'');
          if(m){ return '#'+[1,2,3].map(function(i){ var v=(+m[i]).toString(16); return v.length<2?'0'+v:v; }).join(''); }
        }
      }catch(e){}
      return null;
    }
    /* Commit a typed value (Enter / blur): resolve + apply, or flash red if unrecognised. */
    function commitTyped(el){
      var hx=resolveColorInput(el.value);
      if(hx){ setHex(hx); return true; }
      el.classList.add('qf-input-bad'); setTimeout(function(){ el.classList.remove('qf-input-bad'); },800); return false;
    }
    window.gcResolveColor=resolveColorInput;
    var dragging=false;
    track.addEventListener('pointerdown',function(e){dragging=true;try{track.setPointerCapture(e.pointerId);}catch(_){};setHueFromX(e.clientX);e.preventDefault();});
    track.addEventListener('pointermove',function(e){if(dragging) setHueFromX(e.clientX);});
    track.addEventListener('pointerup',function(e){dragging=false;try{track.releasePointerCapture(e.pointerId);}catch(_){};});
    track.addEventListener('pointercancel',function(){dragging=false;});
    track.addEventListener('keydown',function(e){
      var step=e.shiftKey?16:4;
      if(e.key==='ArrowLeft'||e.key==='ArrowDown'){hue=Math.max(0,hue-step);paint();e.preventDefault();}
      if(e.key==='ArrowRight'||e.key==='ArrowUp'){hue=Math.min(360,hue+step);paint();e.preventDefault();}
      if(e.key==='Home'){hue=0;paint();e.preventDefault();}
      if(e.key==='End'){hue=360;paint();e.preventDefault();}
    });
    hexIn.addEventListener('input',function(){
      var v=hexIn.value.trim();
      if(/^#?[0-9a-fA-F]{6}$/.test(v)){if(v.charAt(0)!=='#')v='#'+v; setHex(v);}
    });
    /* names (and partial hex) resolve on Enter / blur so live typing isn't disrupted */
    hexIn.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); commitTyped(hexIn); } });
    hexIn.addEventListener('change',function(){ commitTyped(hexIn); });
    document.querySelectorAll('.qf-color-preset').forEach(function(btn){
      btn.addEventListener('click',function(){setHex(btn.dataset.hex);});
    });
    var saved=null; try{saved=localStorage.getItem('gc-quote-color');}catch(e){}
    if(saved && /^#[0-9a-f]{6}$/i.test(saved)) setHex(saved); else paint();

    /* Swatch -> full hex-grid picker: choose ANY colour visually (grid) or by exact hex; the swatch + readout showcase the pick live. */
    (function(){
      var pop=document.getElementById('qf-hexgrid-pop');
      var grid=document.getElementById('qf-hexgrid');
      var popInput=document.getElementById('qf-hexgrid-input');
      var closeB=document.getElementById('qf-hexgrid-close');
      if(!pop||!grid) return;
      function gray(L){ L=Math.max(0,Math.min(255,Math.round(L/100*255))).toString(16); if(L.length<2)L='0'+L; return ('#'+L+L+L).toUpperCase(); }
      function cellHTML(hx){ hx=hx.toUpperCase(); return '<button type="button" class="qf-hexgrid-cell" data-hex="'+hx+'" style="background:'+hx+'" title="'+hx+'" aria-label="Select '+hx+'"></button>'; }
      var hues=[0,25,45,90,150,175,200,225,260,290,320,345], lights=[82,66,52,40,28], html='';
      for(var i=0;i<12;i++){ html+=cellHTML(gray(96-i*8)); }                 /* neutral ramp, white -> black */
      lights.forEach(function(L){ hues.forEach(function(h){ html+=cellHTML(hslToHex(h,62,L)); }); });  /* 12 hues x 5 shades */
      grid.innerHTML=html;
      var hashEl=pop.querySelector('.qf-hexgrid-hash');
      /* Hide the leading "#" while the field holds a colour NAME (the # only makes sense for a hex value). */
      function syncHash(){ if(!hashEl) return; var v=popInput.value.trim(); hashEl.style.display=(v===''||/^#?[0-9a-f]{0,6}$/i.test(v))?'':'none'; }
      function openGrid(){ pop.hidden=false; void pop.offsetHeight; pop.classList.add('is-open'); swatch.setAttribute('aria-expanded','true'); updateReadout(hexIn.value); syncHash(); setTimeout(function(){ try{popInput.focus();popInput.select();}catch(e){} },60); }
      function closeGrid(){ pop.classList.remove('is-open'); swatch.setAttribute('aria-expanded','false'); setTimeout(function(){ if(!pop.classList.contains('is-open')) pop.hidden=true; },300); }
      swatch.style.cursor='pointer'; swatch.setAttribute('role','button'); swatch.setAttribute('tabindex','0'); swatch.setAttribute('aria-haspopup','dialog'); swatch.setAttribute('aria-expanded','false'); swatch.setAttribute('aria-label','Open colour grid to pick any hex'); swatch.removeAttribute('aria-hidden');
      swatch.addEventListener('click',function(e){ e.stopPropagation(); pop.classList.contains('is-open')?closeGrid():openGrid(); });
      swatch.addEventListener('keydown',function(e){ if(e.key==='Enter'||e.key===' '){ e.preventDefault(); pop.classList.contains('is-open')?closeGrid():openGrid(); } });
      grid.addEventListener('click',function(e){ var c=e.target.closest('.qf-hexgrid-cell'); if(!c) return; setHex(c.dataset.hex); });
      /* Accept a typed hex OR colour name. Live-apply when it resolves (the field keeps the user's text
         because updateReadout only writes the hex back when the field is NOT focused); commit on Enter/blur. */
      popInput.addEventListener('input',function(){ syncHash(); var hx=resolveColorInput(popInput.value); if(hx) setHex(hx); });
      popInput.addEventListener('keydown',function(e){ if(e.key==='Enter'){ e.preventDefault(); commitTyped(popInput); } });
      popInput.addEventListener('change',function(){ commitTyped(popInput); });
      closeB && closeB.addEventListener('click',closeGrid);
      document.addEventListener('click',function(e){ if(pop.hidden) return; if(e.target===swatch||(e.target.closest&&e.target.closest('#qf-hexgrid-pop'))) return; closeGrid(); });
      document.addEventListener('keydown',function(e){ if(e.key==='Escape' && !pop.hidden) closeGrid(); });
    })();
  })();

  /* ==== v13.1 ============================================================
     1) Auto-illuminate the m01 hero spotlight after page load
     2) Search placeholder typewriter (cycles short product keywords)
     3) Color-row scroll helper + arrow-visibility binder for both color rows
        and both leather strips (Featured / Limited Exotic)
     ====================================================================== */
  (function v131(){
    /* 1. Auto-illuminate after load */
    function illuminate(){
      var hero = document.getElementById('m01Hero');
      if(hero && !hero.classList.contains('gold-illuminated')) hero.classList.add('gold-illuminated');
    }
    if(document.readyState === 'complete') setTimeout(illuminate, 700);
    else window.addEventListener('load', function(){ setTimeout(illuminate, 700); });

    /* 2. Search placeholder typewriter */
    (function typewriter(){
      var input = document.getElementById('bubble-search');
      if(!input) return;
      var raw = input.getAttribute('data-search-typewriter') || '';
      var words = raw.split(',').map(function(s){return s.trim();}).filter(Boolean);
      if(!words.length) return;
      var prefix = 'Search ';
      var i = 0, j = 0, deleting = false;
      function tick(){
        if(document.activeElement === input || (input.value && input.value.length)){
          setTimeout(tick, 1800); return;
        }
        var w = words[i];
        input.placeholder = prefix + w.substring(0, j);
        if(!deleting){
          if(j < w.length){ j++; setTimeout(tick, 78 + Math.random()*40); }
          else { deleting = true; setTimeout(tick, 1500); }
        } else {
          if(j > 0){ j--; setTimeout(tick, 38); }
          else { deleting = false; i = (i + 1) % words.length; setTimeout(tick, 220); }
        }
      }
      setTimeout(tick, 1200);
    })();

    /* 3. Color-row + leather-strip arrow scroll + visibility binders */
    window.scrollColorRow = function(tier, dir){
      var el = document.getElementById('m23-color-track-' + tier); if(!el) return;
      el.scrollBy({left: dir * Math.max(180, el.clientWidth * 0.7), behavior:'smooth'});
    };
    window.scrollLeatherStripById = function(id, dir){
      var el = document.getElementById(id); if(!el) return;
      el.scrollBy({left: dir * Math.max(220, el.clientWidth * 0.7), behavior:'smooth'});
    };
    function bindArrows(scrollEl, prevBtn, nextBtn){
      if(!scrollEl || !prevBtn || !nextBtn) return;
      function update(){
        var max = scrollEl.scrollWidth - scrollEl.clientWidth;
        var atStart = scrollEl.scrollLeft <= 2;
        var atEnd = scrollEl.scrollLeft >= max - 2;
        var canScroll = max > 2;
        prevBtn.classList.toggle('show', canScroll && !atStart);
        nextBtn.classList.toggle('show', canScroll && !atEnd);
      }
      scrollEl.addEventListener('scroll', update, {passive:true});
      window.addEventListener('resize', update);
      setTimeout(update, 60);
      setTimeout(update, 400);
    }
    function bindAll(){
      ['popular','more'].forEach(function(tier){
        var s = document.getElementById('m23-color-track-' + tier);
        var row = s && s.closest('.m23-color-row');
        if(!row) return;
        bindArrows(s, row.querySelector('.m23-color-arrow.prev'), row.querySelector('.m23-color-arrow.next'));
      });
      ['m23-leather-scroll-featured','m23-leather-scroll-limited'].forEach(function(id){
        var s = document.getElementById(id);
        var strip = s && s.closest('.m23-leather-strip');
        if(!strip) return;
        bindArrows(s, strip.querySelector('.m23-leather-arrow.prev'), strip.querySelector('.m23-leather-arrow.next'));
      });
    }
    if(document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindAll);
    else bindAll();
  })();
  
}

/* GCB2B-WIRE:quote-form */
/* Added by scripts/wire-quote-form.mjs (idempotent). Replaces the mockup's inline onsubmit: builds contact[body]
   (GCB2B-QUOTE marker + readable summary + JSON) and contact[source] from the on-page selections and the quote
   cart (localStorage 'gc-quote-items'), swaps the button label as a pending state, and does NOT preventDefault —
   the native POST to /contact proceeds. Draft + cart keys are cleared by the section's success block. */
(function(){
  var form=document.getElementById('m14-form'); if(!form) return;
  if(form.getAttribute('data-gc-wired')==='1') return; form.setAttribute('data-gc-wired','1');
  var REQUESTS=[['request_line_sheet','Line sheet'],['request_call','Book a call'],['request_swatches','Leather swatches']];
  function val(id){ var e=document.getElementById(id); return e&&e.value?String(e.value).trim():''; }
  function byName(n){ return form.querySelector('[name="'+n+'"]'); }
  function split(s,sep){ return s?s.split(sep).map(function(x){return x.trim();}).filter(Boolean):[]; }
  function locale(){
    try{ if(window.Shopify&&window.Shopify.locale) return String(window.Shopify.locale); }catch(e){}
    return document.documentElement.getAttribute('lang')||'';
  }
  function context(key){
    try{ var p=new URLSearchParams(location.search).get(key); if(p) return p.trim(); }catch(e){}
    var c=window.GCB2B_QUOTE_CONTEXT; if(c&&c[key]) return String(c[key]).trim();
    return '';
  }
  function cartItems(){
    var items=[]; try{ items=JSON.parse(localStorage.getItem('gc-quote-items')||'[]')||[]; }catch(e){ items=[]; }
    return items.filter(function(x){ return typeof x==='string'&&x.trim(); }).map(function(x){ return x.trim(); });
  }
  function colourNames(hexes){
    return hexes.map(function(h){
      var n=''; try{ if(typeof window.nameForHex==='function') n=String(window.nameForHex(h)||''); }catch(e){}
      var uc=h.toUpperCase();
      return (n&&n.toUpperCase()!==uc)?(n+' ('+uc+')'):uc;
    });
  }
  function collect(){
    var requests=[]; REQUESTS.forEach(function(p){ var cb=byName('contact['+p[0]+']'); if(cb&&cb.checked) requests.push(p[1]); });
    var hex=split(val('qf-colors'),',');
    var ind=byName('contact[industry]'), br=byName('contact[branding]');
    return {
      products: cartItems(),
      product_interest: val('hidden-product-interest'),
      colours: colourNames(hex),
      colour_hex: hex,
      materials: split(val('qf-material'),','),
      quantity_band: val('qf-qty'),
      quantity_label: ((form.querySelector('[data-qf-val]')||{}).textContent||'').trim(),
      quantity_custom: val('qf-qty-custom'),
      timeline: val('qf-needby'),
      industry: (ind&&ind.value)||context('industry'),
      branding: (br&&br.value)||context('branding'),
      requests: requests,
      page: location.pathname,
      locale: locale()
    };
  }
  function summary(d){
    var L=['GCB2B-QUOTE',''];
    L.push('Products: '+(d.products.length?d.products.join('; '):'(none added)'));
    if(d.product_interest) L.push('Product interest: '+d.product_interest);
    L.push('Colours: '+(d.colours.length?d.colours.join(', '):'(none)'));
    L.push('Materials: '+(d.materials.length?d.materials.join(', '):'(none)'));
    L.push('Quantity band: '+(d.quantity_label||d.quantity_band||'(not set)')+(d.quantity_custom?' - '+d.quantity_custom:''));
    if(d.timeline) L.push('Need by: '+d.timeline);
    if(d.industry) L.push('Industry: '+d.industry);
    if(d.branding) L.push('Branding: '+d.branding);
    L.push('Requests: '+(d.requests.length?d.requests.join(', '):'(none)'));
    L.push('Source: '+d.page+' | '+(d.locale||'?'));
    L.push(''); L.push(JSON.stringify(d));
    return L.join('\n');
  }
  function fill(){
    var d=collect();
    var body=byName('contact[body]'); if(body) body.value=summary(d);
    var src=byName('contact[source]'); if(src) src.value=d.page+' | '+(d.locale||'');
    var ind=byName('contact[industry]'); if(ind&&!ind.value&&d.industry) ind.value=d.industry;
    var br=byName('contact[branding]'); if(br&&!br.value&&d.branding) br.value=d.branding;
  }
  fill();
  form.addEventListener('submit',function(){
    fill();
    var btn=form.querySelector('button[type=submit]');
    if(btn){
      if(!btn.getAttribute('data-gc-label')) btn.setAttribute('data-gc-label',btn.textContent);
      btn.textContent=btn.getAttribute('data-gc-pending')||btn.textContent; btn.setAttribute('aria-busy','true');
      setTimeout(function(){ btn.disabled=true; },0);
    }
    /* no preventDefault: native POST to /contact */
  });
  window.addEventListener('pageshow',function(){
    var btn=form.querySelector('button[type=submit]'); var l=btn&&btn.getAttribute('data-gc-label');
    if(l){ btn.textContent=l; btn.disabled=false; btn.removeAttribute('aria-busy'); }
  });
})();
